import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import {
    PlusCircle, Package, Trash2, Edit, ExternalLink,
    BarChart3, Loader2, ShoppingBag, Eye, Tag,
    Briefcase, ChevronRight, LayoutDashboard, Settings,
    MapPin, LogOut, Upload, Camera, DollarSign, X, ClipboardList,
    Search, ShoppingCart, CreditCard, Smartphone, Minus,
    Volume2, VolumeX, Bell, BellRing, Lock, User,
    Plus, Trash, ShieldX, ShieldCheck, Check, Clock, Printer, ScanLine, Utensils, Monitor, Wrench, Shirt, Hammer, Pill, Car, Store, Wine, CupSoda
} from "lucide-react";
import BarcodeScanner from "../components/BarcodeScanner";

const getCategoryIcon = (category) => {
    switch(category) {
        case 'food': return Utensils;
        case 'bwason': return Wine;
        case 'phones': return Smartphone;
        case 'electronics': return Monitor;
        case 'services': return Utensils;
        case 'fashion': return Shirt;
        case 'construction': return Hammer;
        case 'pharmacy': return Pill;
        case 'autoparts': return Car;
        case 'depotalimentaire': return Store;
        default: return Utensils;
    }
};

const getCategoryColor = (category) => {
    switch(category) {
        case 'food': return 'bg-orange-50 text-orange-500';
        case 'bwason': return 'bg-purple-50 text-purple-600';
        case 'construction': return 'bg-amber-50 text-amber-600';
        case 'pharmacy': return 'bg-emerald-50 text-emerald-600';
        case 'autoparts': return 'bg-slate-100 text-slate-600';
        case 'depotalimentaire': return 'bg-yellow-50 text-yellow-600';
        case 'phones': return 'bg-blue-50 text-blue-500';
        case 'electronics': return 'bg-indigo-50 text-indigo-500';
        case 'fashion': return 'bg-pink-50 text-pink-500';
        case 'services': return 'bg-rose-50 text-rose-500';
        default: return 'bg-gray-100 text-gray-400';
    }
};
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription
} from "@/components/ui/dialog";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

const API = (process.env.REACT_APP_BACKEND_URL || "") + "/api";


const DEFAULT_PRODUCT_IMAGES = [
    { name: "Maket / Manje", url: "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='400' height='400'><rect width='400' height='400' fill='%23FF9900'/><text x='50%' y='50%' font-size='150' text-anchor='middle' dy='.3em'>ðŸ›’</text></svg>" },
    { name: "Materyel", url: "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='400' height='400'><rect width='400' height='400' fill='%233B82F6'/><text x='50%' y='50%' font-size='150' text-anchor='middle' dy='.3em'>ðŸ§±</text></svg>" },
    { name: "Elektwonik", url: "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='400' height='400'><rect width='400' height='400' fill='%2310B981'/><text x='50%' y='50%' font-size='150' text-anchor='middle' dy='.3em'>ðŸ’»</text></svg>" },
    { name: "Rad / Bote", url: "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='400' height='400'><rect width='400' height='400' fill='%23EC4899'/><text x='50%' y='50%' font-size='150' text-anchor='middle' dy='.3em'>ðŸ‘—</text></svg>" },
    { name: "Sevis / Lot", url: "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='400' height='400'><rect width='400' height='400' fill='%238B5CF6'/><text x='50%' y='50%' font-size='150' text-anchor='middle' dy='.3em'>ðŸ“¦</text></svg>" }
];

export const SellerDashboard = () => {
    const navigate = useNavigate();
    const [products, setProducts] = useState([]);
    const [orders, setOrders] = useState([]);
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [stats, setStats] = useState({ total: 0, active: 0 });
    const [seller, setSeller] = useState(null);
    const [wallet, setWallet] = useState({ total_earnings: 0, available_balance: 0, withdrawals: [] });
    const [listRequests, setListRequests] = useState([]);

    // Location state
    const [storeLocation, setStoreLocation] = useState(null);
    const [locationLoading, setLocationLoading] = useState(false);
    const [activeTab, setActiveTab] = useState("products"); // products, orders, list_requests, pos, reports
    const [reportPeriod, setReportPeriod] = useState("month"); // day, week, month, year
    const [reportDateRange, setReportDateRange] = useState({ start: "", end: "" });
    const [posCart, setPosCart] = useState([]);
    const [posBuyerPhone, setPosBuyerPhone] = useState("");
    const [mobileTab, setMobileTab] = useState("products"); // products, cart

    // POS Delivery State
    const [posDeliveryEnabled, setPosDeliveryEnabled] = useState(false);
    const [posDeliveryAddress, setPosDeliveryAddress] = useState("");
    const [posDeliveryKm, setPosDeliveryKm] = useState("");
    
    // Audio Notification State
    const [isSoundEnabled, setIsSoundEnabled] = useState(true);
    const audioRef = useRef(new Audio("https://assets.mixkit.co/active_storage/sfx/2869/2869-preview.mp3"));
    const prevOrdersCount = useRef(0);
    const prevListRequestsCount = useRef(0);
    const isFirstLoad = useRef(true);
    const [isAlarmActive, setIsAlarmActive] = useState(false);
    const [isWakeLockActive, setIsWakeLockActive] = useState(false);
    const wakeLockRef = useRef(null);

    // Withdraw Modal State
    const [showWithdrawModal, setShowWithdrawModal] = useState(false);
    const [withdrawLoading, setWithdrawLoading] = useState(false);
    const [withdrawAmount, setWithdrawAmount] = useState("");
    const [withdrawPhone, setWithdrawPhone] = useState("");

    // Add Modal State
    const [showAddModal, setShowAddModal] = useState(false);
    const [showFastPosModal, setShowFastPosModal] = useState(false);
    const [fastPosFormData, setFastPosFormData] = useState({ title: '', price_htg: '', category: 'food', stock: '' });
    const [addLoading, setAddLoading] = useState(false);
    const [formData, setFormData] = useState({
        title: "", description: "", price_htg: "", category: "phones",
        type: "physical", location: "Ayiti", condition: "new", stock: 1, images: [""],
        vehicle_required: "moto"
    });

    // Edit Modal State
    const [editingProduct, setEditingProduct] = useState(null);
    const [editLoading, setEditLoading] = useState(false);
    const [editFormData, setEditFormData] = useState({
        type: "physical", location: "Ayiti", condition: "new", stock: 1, images: [""], is_active: true, barcode: ""
    });

    const [showScannerModal, setShowScannerModal] = useState(false);
    const [showCashCalculatorModal, setShowCashCalculatorModal] = useState(false);
    const [amountTendered, setAmountTendered] = useState("");

    // Cashier State
    const [activeCashier, setActiveCashier] = useState(null);
    const [tempCashier, setTempCashier] = useState(null);
    const [enteredPin, setEnteredPin] = useState("");
    const [isAdminUnlocked, setIsAdminUnlocked] = useState(() => sessionStorage.getItem("adminUnlocked") === "true");
    const [showAdminLogin, setShowAdminLogin] = useState(false);
    const [adminPassword, setAdminPassword] = useState("");
    const [adminLoginLoading, setAdminLoginLoading] = useState(false);

    // Delivery Request State
    const [showDeliveryModal, setShowDeliveryModal] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [distanceKm, setDistanceKm] = useState("");
    const [requestLoading, setRequestLoading] = useState(false);

    // List Quote State
    const [showQuoteModal, setShowQuoteModal] = useState(false);
    
    // Receipt Preview State
    const [showReceiptModal, setShowReceiptModal] = useState(false);
    const [receiptOrder, setReceiptOrder] = useState(null);

    // Profile Edit State
    const [showProfileModal, setShowProfileModal] = useState(false);
    const [profileData, setProfileData] = useState({ store_name: "", phone: "", address: "", logo: "", cashiers: [] });
    const [profileLoading, setProfileLoading] = useState(false);

    const [selectedList, setSelectedList] = useState(null);
    const [quoteItems, setQuoteItems] = useState([{ name: "", price_htg: "", quantity: 1 }]);
    const [quoteLoading, setQuoteLoading] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem("seller_token");
        if (!token) {
            toast.info("Tanpri konekte kòm machann pou w ka wè dashboard ou.");
            return navigate("/seller/login");
        }

        const sData = localStorage.getItem("seller_data");
        if (sData) setSeller(JSON.parse(sData));

        fetchInitialData();
    }, [navigate]);

    const fetchInitialData = async () => {
        setLoading(true);
        const token = localStorage.getItem("seller_token");
        try {
            const [prodRes, catRes, walletRes, ordersRes, listRequestsRes] = await Promise.all([
                axios.get(`${API}/marketplace/my-products`, {
                    headers: { Authorization: `Bearer ${token}` }
                }),
                axios.get(`${API}/marketplace/categories`),
                axios.get(`${API}/marketplace/my-wallet`, {
                    headers: { Authorization: `Bearer ${token}` }
                }).catch(() => ({ data: { total_earnings: 0, available_balance: 0, withdrawals: [] } })),
                axios.get(`${API}/marketplace/my-orders`, {
                    headers: { Authorization: `Bearer ${token}` }
                }),
                axios.get(`${API}/marketplace/list-requests/seller`, {
                    headers: { Authorization: `Bearer ${token}` }
                })
            ]);
            setProducts(prodRes.data);
            setCategories(catRes.data);
            setOrders(ordersRes.data || []);
            setListRequests(listRequestsRes.data || []);
            if (walletRes.data.success) {
                setWallet(walletRes.data);
            }
            
            // Auto-update seller profile to get approval status changes
            const sData = localStorage.getItem("seller_data");
            if (sData) {
                try {
                    const s = JSON.parse(sData);
                    if (s.id) {
                        axios.get(`${API}/sellers/`).then(res => {
                            if (res.data) {
                                setSeller(res.data);
                                localStorage.setItem("seller_data", JSON.stringify(res.data));
                            }
                        }).catch(e => console.error("Error updating seller profile", e));
                    }
                } catch(e) {}
            }
            setStats({
                total: prodRes.data.length,
                active: prodRes.data.filter(p => p.is_active).length
            });

            // Handle New Audio Alerts
            const newOrdersCount = ordersRes.data?.length || 0;
            const newListRequestsCount = listRequestsRes.data?.length || 0;

            if (!isFirstLoad.current) {
                console.log(`Polling Check - Orders: ${newOrdersCount} vs ${prevOrdersCount.current}, Lists: ${newListRequestsCount} vs ${prevListRequestsCount.current}`);
                if (newOrdersCount > prevOrdersCount.current || newListRequestsCount > prevListRequestsCount.current) {
                    if (isSoundEnabled) {
                        toast.info("NOUVO KÒMAND! ðŸš¨", { 
                            duration: Infinity, 
                            action: {
                                label: 'STOP SON',
                                onClick: () => stopAlarm()
                            }
                        });
                        startAlarm();
                    }
                }
            }
            
            prevOrdersCount.current = newOrdersCount;
            prevListRequestsCount.current = newListRequestsCount;
            isFirstLoad.current = false;

        } catch (error) {
            console.error("Dashboard error:", error);
            toast.error("Pa kapab chaje kont ou pou kounye a.");
        } finally {
            setLoading(false);
        }
    };

    const handleFastPosSubmit = async (e) => {
        e.preventDefault();
        setAddLoading(true);
        try {
            const payload = {
                title: fastPosFormData.title,
                description: "Pwodwi otomatik POS",
                price_htg: parseFloat(fastPosFormData.price_htg),
                category: fastPosFormData.category,
                stock: fastPosFormData.stock ? parseInt(fastPosFormData.stock) : 9999,
                type: "physical",
                condition: "new",
                display_on: "pos",
                vehicle_required: "moto",
                images: []
            };

            await axios.post(`${API}/marketplace/products`, payload, {
                headers: { Authorization: `Bearer ${localStorage.getItem("seller_token")}` }
            });
            
            toast.success("Pwodwi POS ajoute!");
            setShowFastPosModal(false);
            setFastPosFormData({ title: '', price_htg: '', category: 'food', stock: '' });
            fetchInitialData();
        } catch (error) {
            console.error(error);
            toast.error("Echèk lè n ap ajoute pwodwi a");
        } finally {
            setAddLoading(false);
        }
    };

    // Auto-refresh orders every 10 seconds for real-time feel
    useEffect(() => {
        const interval = setInterval(() => {
            fetchInitialData();
        }, 10000);
        return () => clearInterval(interval);
    }, []);

    const startAlarm = () => {
        setIsAlarmActive(true);
        audioRef.current.loop = true;
        audioRef.current.play().catch(e => console.error("Audio error:", e));
    };

    const stopAlarm = () => {
        setIsAlarmActive(false);
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
        audioRef.current.loop = false;
        toast.dismiss();
    };

    const requestWakeLock = async () => {
        try {
            if ('wakeLock' in navigator) {
                wakeLockRef.current = await navigator.wakeLock.request('screen');
                setIsWakeLockActive(true);
                console.log('Screen Wake Lock active');
                
                wakeLockRef.current.addEventListener('release', () => {
                    setIsWakeLockActive(false);
                    console.log('Wake Lock was released');
                });
            }
        } catch (err) {
            console.log('Wake Lock error:', err.message);
            setIsWakeLockActive(false);
        }
    };

    // Keep Screen Awake (Wake Lock API)
    useEffect(() => {
        requestWakeLock();

        const handleVisibilityChange = async () => {
            if (wakeLockRef.current !== null && document.visibilityState === 'visible') {
                await requestWakeLock();
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            if (wakeLockRef.current !== null) {
                wakeLockRef.current.release();
            }
        };
    }, []);

    const handleFileUpload = async (event, isEdit = false) => {
        const file = event.target.files[0];
        if (!file) return;

        if (file.size > 50 * 1024 * 1024) {
            toast.error("Imaj la twò gwo anpil. Maksimòm 50MB.");
            return;
        }

        const formDataObj = new FormData();
        formDataObj.append("file", file);

        try {
            const res = await axios.post(`${API}/marketplace/upload`, formDataObj);

            if (res.data.url) {
                // Ensure we use the correct backend URL if relative path returned
                const imageUrl = res.data.url.startsWith("http") ? res.data.url : `${window.location.origin}${res.data.url}`;
                if (isEdit) {
                    setEditFormData(prev => {
                        const newImages = (prev.images || []).filter(img => img && img !== "");
                        if(newImages.length < 3) return { ...prev, images: [...newImages, imageUrl] };
                        toast.error("Ou ka poze 3 foto maksimòm.");
                        return prev;
                    });
                } else {
                    setFormData(prev => {
                        const newImages = (prev.images || []).filter(img => img && img !== "");
                        if(newImages.length < 3) return { ...prev, images: [...newImages, imageUrl] };
                        toast.error("Ou ka poze 3 foto maksimòm.");
                        return prev;
                    });
                }
                toast.success("Imaj moute ak siksè!");
            }
        } catch (error) {
            console.error("Upload error:", error);
            toast.error("Erè nan voye imaj la.");
        }
    };

    const handleRemoveImage = (index, isEdit = false) => {
        if(isEdit) {
            setEditFormData(prev => {
                const newArr = [...prev.images];
                newArr.splice(index, 1);
                return {...prev, images: newArr};
            })
        } else {
            setFormData(prev => {
                const newArr = [...prev.images];
                newArr.splice(index, 1);
                return {...prev, images: newArr};
            })
        }
    };

    const handleLogout = () => {
        localStorage.removeItem("seller_token");
        localStorage.removeItem("seller_data");
        toast.success("Ou dekonèkte avèk siksè.");
        navigate("/seller/login");
    };

    const handleWithdrawSubmit = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem("seller_token");
        setWithdrawLoading(true);
        try {
            await axios.post(`${API}/marketplace/withdrawals`, {
                amount_htg: parseFloat(withdrawAmount),
                payment_method: "moncash",
                payment_details: withdrawPhone
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success("Demann retrè soumèt avèk siksè! N ap trete l trè byento.");
            setShowWithdrawModal(false);
            setWithdrawAmount("");
            setWithdrawPhone("");
            fetchInitialData();
        } catch (error) {
            toast.error(error.response?.data?.detail || "Erè nan fè demann nan.");
        } finally {
            setWithdrawLoading(false);
        }
    };

    const handleDelete = async (productId) => {
        if (!window.confirm("Èske ou sèten ou vle efase pwodwi sa a nèt?")) return;

        const token = localStorage.getItem("seller_token");
        try {
            await axios.delete(`${API}/marketplace/products/${productId}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success("Pwodwi efase avèk siksè.");
            fetchInitialData();
        } catch (error) {
            toast.error("Erè nan efase pwodwi a.");
        }
    };

    const handleAddSubmit = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem("seller_token");
        setAddLoading(true);
        try {
            await axios.post(`${API}/marketplace/products`, {
                ...formData,
                price_htg: parseFloat(formData.price_htg)
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success("Nouvo pwodwi poste avèk siksè!");
            setShowAddModal(false);
            setFormData({
                title: "", description: "", price_htg: "", category: "phones",
                type: "physical", condition: "new", stock: 1, images: [""],
                display_on: "marketplace", vehicle_required: "moto"
            });
            fetchInitialData();
        } catch (error) {
            toast.error("Erè nan poste pwodwi a.");
        } finally {
            setAddLoading(false);
        }
    };

    const handleEditClick = (product) => {
        setEditFormData({
            title: product.title,
            description: product.description,
            price_htg: product.price_htg,
            category: product.category,
            type: product.type,
            location: product.location || "Pòtoprens",
            condition: product.condition || "new",
            stock: product.stock,
            images: product.images && product.images.length ? [...product.images] : [""],
            is_active: product.is_active,
            display_on: product.display_on || "marketplace"
        });
        setEditingProduct(product);
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem("seller_token");
        setEditLoading(true);
        try {
            await axios.put(`${API}/marketplace/products/${editingProduct.id}`, {
                ...editFormData,
                price_htg: parseFloat(editFormData.price_htg),
                stock: parseInt(editFormData.stock, 10)
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success("Pwodwi a modifye avèk siksè!");
            setEditingProduct(null);
            fetchInitialData();
        } catch (error) {
            toast.error("Erè nan modifye pwodwi a.");
        } finally {
            setEditLoading(false);
        }
    };

    const handleUpdateOrderStatus = async (orderId, newStatus) => {
        try {
            const token = localStorage.getItem('seller_token');
            const endpoint = newStatus === 'preparing' ? 'prepare' : newStatus === 'ready' ? 'ready' : null;
            if (!endpoint) {
                toast.error("Estati sa pa koni.");
                return;
            }
            const res = await axios.post(`${API}/marketplace/orders/${orderId}/${endpoint}`, 
                {},
                { headers: { Authorization: `Bearer ${token}` } }
            );
            if (res.data.success) {
                toast.success(`Kòmand lan kounye a: ${newStatus.toUpperCase()}`);
                // Refresh local state with Safety
                setOrders(prev => prev.map(o => (o.id === orderId || o.order_id === orderId) ? {
                    ...o, 
                    delivery_info: { ...(o.delivery_info || {}), status: newStatus }
                } : o));
            }
        } catch (error) {
            console.error("Error updating status:", error);
            toast.error("Echèk nan aktyalize estati.");
        }
    };

    const handlePrintReceipt = (order) => {
        setReceiptOrder(order);
        setShowReceiptModal(true);
    };

    const executePrint = () => {
        if (!receiptOrder) return;
        const printWindow = window.open('', '', 'width=400,height=600');
        const d = new Date(receiptOrder.created_at || Date.now());
        printWindow.document.write(`
            <html>
                <head>
                    <title>Resi Vant - ${receiptOrder.id}</title>
                    <style>
                        @page { margin: 0; size: 58mm 210mm; }
                        body { 
                            font-family: 'Courier New', Courier, monospace; 
                            width: 58mm;
                            margin: 0 auto; 
                            padding: 10px; 
                            color: #000; 
                            font-size: 12px;
                            line-height: 1.2;
                        }
                        h2 { text-align: center; border-bottom: 1px dashed #000; padding-bottom: 5px; margin: 5px 0; font-size: 16px; }
                        h3 { text-align: center; margin: 2px 0; font-size: 14px; }
                        p { margin: 3px 0; word-break: break-all; }
                        .center { text-align: center; }
                        .bold { font-weight: bold; }
                        .divider { border-top: 1px dashed #000; margin: 5px 0; }
                        .flex-space { display: flex; justify-content: space-between; }
                        .total { font-weight: bold; font-size: 14px; margin-top: 5px; }
                        .footer { text-align: center; margin-top: 15px; font-size: 10px; }
                    </style>
                </head>
                <body>
                    ${seller?.logo ? `<div class="center" style="margin-bottom: 5px;"><img src="${seller.logo}" alt="Logo" style="max-width: 40mm; max-height: 30mm; border-radius: 5px;" /></div>` : ''}
                    <h2 style="margin-top: 0;">${seller?.store_name || 'BVGLINK POS'}</h2>
                    ${seller?.address ? `<p class="center" style="font-size: 10px; margin-top: -3px;">${seller.address}</p>` : ''}
                    ${seller?.phone ? `<p class="center" style="font-size: 10px; margin-top: -3px; margin-bottom: 5px;">Tel: ${seller.phone}</p>` : ''}
                    <h3>RESI VANT</h3>
                    <p class="center">${d.toLocaleDateString('fr-FR')} ${d.toLocaleTimeString('fr-FR')}</p>
                    <div class="divider"></div>
                    <p><span class="bold">CMD No:</span> ${receiptOrder.id.slice(0, 8).toUpperCase()}</p>
                    <p><span class="bold">KLiYAN:</span> ${receiptOrder.buyer_phone}</p>
                    <p><span class="bold">KASYE:</span> ${receiptOrder.cashier_name || 'Pwopriyetè'}</p>
                    
                    <div class="divider"></div>
                    <p class="bold" style="text-decoration: underline;">ATIK(Yo):</p>
                    <p>${receiptOrder.product_title}</p>
                    <div class="divider"></div>
                    
                    <div class="flex-space total">
                        <span>TOTAL:</span>
                        <span>${(receiptOrder.seller_amount_htg || 0).toLocaleString()} HTG</span>
                    </div>
                    ${receiptOrder.tendered_htg ? `
                    <div class="divider"></div>
                    <div class="flex-space" style="font-size: 11px;">
                        <span>Kòb Bay:</span>
                        <span>${receiptOrder.tendered_htg.toLocaleString()} HTG</span>
                    </div>
                    <div class="flex-space bold" style="font-size: 11px;">
                        <span>MONNEN:</span>
                        <span>${receiptOrder.change_htg.toLocaleString()} HTG</span>
                    </div>
                    ` : ''}
                    
                    <p style="margin-top: 10px;"><span class="bold">Peman:</span> ${receiptOrder.payment_status === 'completed' ? 'PEYE' : 'AN ATANT'}</p>
                    <div class="divider"></div>
                    
                    <div class="footer">
                        <p>Mesi pou biznis ou!</p>
                        <p>*** Powered by BVGLink ***</p>
                    </div>
                </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => {
            printWindow.print();
        }, 300);
    };

    const handleVerifyPayment = async (orderId) => {
        try {
            const response = await axios.post(`${API}/moncash/verify-payment?order_id=${orderId}`);
            if (response.data.status === 'completed' || response.data.success) {
                toast.success("Peman verifye! Balans ou mete ajou.");
                fetchInitialData();
            } else {
                toast.info("Peman an poko fini nan MonCash.");
            }
        } catch (error) {
            toast.error("Erè nan verifye peman.");
        }
    };

    const handleRequestDelivery = async () => {
        if (!distanceKm) return toast.error("Tanpri antre distans la.");
        setRequestLoading(true);
        const token = localStorage.getItem("seller_token");
        try {
            await axios.post(`${API}/marketplace/orders/${selectedOrder.id}/request-delivery`, {
                distance_km: parseFloat(distanceKm)
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success("Demann livrezon voye bay tout chofè ki online!");
            setShowDeliveryModal(false);
            setDistanceKm("");
            fetchInitialData();
        } catch (error) {
            toast.error(error.response?.data?.detail || "Erè nan mande chofè.");
        } finally {
            setRequestLoading(false);
        }
    };

    const handleQuoteSubmit = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem("seller_token");
        if (quoteItems.some(item => !item.price_htg || parseFloat(item.price_htg) <= 0)) {
            toast.error("Tanpri antre yon pri valid pou chak atik.");
            return;
        }

        setQuoteLoading(true);
        try {
            await axios.post(`${API}/marketplace/list-requests/${selectedList.id}/quote`, {
                items: quoteItems
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success("Quote a voye bay kliyan an avèk siksè!");
            setShowQuoteModal(false);
            fetchInitialData();
        } catch (error) {
            console.error("Quote error:", error);
            toast.error("Erè nan voye quote la.");
        } finally {
            setQuoteLoading(false);
        }
    };

    const handleOpenProfile = () => {
        setProfileData({
            store_name: seller?.store_name || "",
            phone: seller?.phone || "",
            address: seller?.address || "",
            logo: seller?.logo || "",
            cashiers: seller?.cashiers || []
        });
        setShowProfileModal(true);
    };

    const handleProfileSubmit = async (e) => {
        e.preventDefault();
        setProfileLoading(true);
        const token = localStorage.getItem("seller_token");
        try {
            const res = await axios.put(`${API}/sellers/profile`, profileData, {
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success("Pwofil aktyalize ak siksè!");
            setSeller(res.data.seller);
            localStorage.setItem("seller_data", JSON.stringify(res.data.seller));
            setShowProfileModal(false);
        } catch (error) {
            toast.error("Erè nan aktyalize pwofil.");
        } finally {
            setProfileLoading(false);
        }
    };

    const playBeep = () => {
        try {
            const ctx = new (window.AudioContext || window.webkitAudioContext)();
            const osc = ctx.createOscillator();
            osc.type = 'sine';
            osc.frequency.setValueAtTime(800, ctx.currentTime);
            osc.connect(ctx.destination);
            osc.start();
            osc.stop(ctx.currentTime + 0.1);
        } catch (e) {}
    };

    const handleBarcodeResult = (code, inputElem = null) => {
        if (!code) return;
        const found = products.find(p => p.is_active && (p.display_on === 'pos' || p.display_on === 'both') && (p.barcode === code || p.id.includes(code) || (p.title || "").toLowerCase().includes(code.toLowerCase())));
        if (found) {
            playBeep();
            setPosCart(prev => {
                const existing = prev.find(i => i.id === found.id);
                if (existing) {
                    return prev.map(i => i.id === found.id ? { ...i, qty: i.qty + 1 } : i);
                }
                return [...prev, { ...found, qty: 1 }];
            });
            toast.success(`Eskane: ${found.title}`);
            setShowScannerModal(false);
            if (inputElem) {
                inputElem.value = "";
                inputElem.focus();
            }
        } else {
            toast.error("Pa jwenn: " + code);
            if (inputElem) {
                inputElem.value = "";
                inputElem.focus();
            }
        }
    };    const parseRequestedItems = (text) => {
        if (!text) return [{ name: "", price_htg: "", quantity: 1 }];
        // Split by lines, commas, or common conjunctions
        const lines = text.split(/[\n,]+|\s+epi\s+|\s+ak\s+|\s+et\s+/i).map(l => l.trim()).filter(l => l.length > 0);
        if (lines.length === 0) return [{ name: "", price_htg: "", quantity: 1 }];
        return lines.map(line => ({ name: line, price_htg: "", quantity: 1 }));
    };

    const handleAdminUnlock = async (e) => {
        e.preventDefault();
        setAdminLoginLoading(true);
        try {
            await axios.post(`${API}/sellers/login`, {
                email: seller?.email,
                password: adminPassword
            });
            
            setIsAdminUnlocked(true);
            setShowAdminLogin(false);
            setAdminPassword("");
            toast.success("Byenveni sou Dashboard la, Mèt Magazen!");
        } catch (error) {
            toast.error("Paskod ou antre a pa bon. Eseye ankò!");
        } finally {
            setAdminLoginLoading(false);
        }
    };

    const isGlobalLocked = seller?.cashiers?.length > 0 && !activeCashier && !isAdminUnlocked;

    if (isGlobalLocked) {
        return (
            <div className="flex flex-col items-center justify-center min-h-screen bg-[#F8FAFC]">
                <div className="bg-white p-8 rounded-[40px] shadow-2xl max-w-sm w-full mx-auto border-none">
                    <div className="w-16 h-16 bg-[#232F3E] rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-xl">
                        <Lock className="w-8 h-8 text-[#FF9900]" />
                    </div>
                    <h3 className="text-2xl font-black text-center uppercase tracking-tighter italic mb-2">Kasye Fèmen</h3>
                    <p className="text-[10px] text-gray-400 font-bold uppercase tracking-widest text-center mb-8">Kiyès k'ap itilize pou vann jodi a?</p>
                    
                    {!showAdminLogin ? (
                        <>
                            {!tempCashier ? (
                                <div className="space-y-3 relative group">
                                    <select 
                                        onChange={(e) => {
                                            const selected = seller.cashiers.find(c => c.name === e.target.value);
                                            if (selected) setTempCashier(selected);
                                        }}
                                        defaultValue=""
                                        className="w-full h-14 bg-gray-50 hover:bg-gray-100 text-gray-900 px-6 pr-12 rounded-2xl border-2 border-gray-100 transition-all font-black uppercase text-xs appearance-none cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#FF9900] focus:border-transparent"
                                    >
                                        <option value="" disabled>-- Chwazi Yon Kasye --</option>
                                        {seller.cashiers.map(c => (
                                            <option key={'select_'+c.name} value={c.name} className="font-bold text-sm text-gray-900 uppercase">
                                                {c.name}
                                            </option>
                                        ))}
                                    </select>
                                    <div className="absolute inset-y-0 right-4 flex items-center pointer-events-none">
                                        <ChevronRight className="w-5 h-5 text-gray-400 rotate-90 transition-transform group-hover:text-[#FF9900]" />
                                    </div>
                                </div>
                            ) : (
                                <div className="flex flex-col items-center animate-in fade-in slide-in-from-right">
                                    <div className="flex items-center gap-2 mb-6">
                                        <span className="text-sm font-black uppercase tracking-widest text-[#232F3E]">{tempCashier.name}</span>
                                        <button onClick={() => {setTempCashier(null); setEnteredPin("");}} className="text-[10px] text-red-500 font-bold underline ml-2 uppercase">Chanje</button>
                                    </div>
                                    <div className="text-center space-y-4">
                                        <div className="flex justify-center gap-3 mb-4">
                                            {[0,1,2,3].map(i => (
                                                <div key={i} className={`w-4 h-4 rounded-full transition-colors duration-300 ${enteredPin.length > i ? 'bg-[#FF9900]' : 'bg-gray-200'}`} />
                                            ))}
                                        </div>
                                        <div className="grid grid-cols-3 gap-3">
                                            {[1,2,3,4,5,6,7,8,9].map(n => (
                                                <Button key={'pin_'+n} variant="outline" className="h-14 rounded-2xl text-xl font-black border-gray-200 hover:bg-gray-50 hover:text-[#FF9900] transition-colors" onClick={() => {
                                                    const p = enteredPin + n;
                                                    if(p.length <= 4) setEnteredPin(p);
                                                    if(p.length === 4) {
                                                        if(p === tempCashier.pin) {
                                                            setActiveCashier(tempCashier);
                                                            setActiveTab("pos"); // FORCE POS TAB
                                                            setTempCashier(null); setEnteredPin("");
                                                            toast.success(`Kès Ouvè pou Kasye: ${tempCashier.name}`);
                                                        } else {
                                                            toast.error("Kòd PIN nan pa bon!");
                                                            setEnteredPin("");
                                                        }
                                                    }
                                                }}>{n}</Button>
                                            ))}
                                            <Button variant="ghost" onClick={() => setEnteredPin("")} className="h-14 rounded-2xl text-[9px] font-black uppercase tracking-widest text-red-400 border border-transparent hover:bg-red-50">Efase</Button>
                                            <Button variant="outline" className="h-14 rounded-2xl text-xl font-black border-gray-200 hover:bg-gray-50 hover:text-[#FF9900] transition-colors" onClick={() => {
                                                const p = enteredPin + '0';
                                                if(p.length <= 4) setEnteredPin(p);
                                                if(p.length === 4) {
                                                    if(p === tempCashier.pin) {
                                                        setActiveCashier(tempCashier);
                                                        setActiveTab("pos"); // FORCE POS TAB
                                                        setTempCashier(null); setEnteredPin("");
                                                        toast.success(`Kès Ouvè pou Kasye: ${tempCashier.name}`);
                                                    } else {
                                                        toast.error("Kòd PIN nan pa bon!");
                                                        setEnteredPin("");
                                                    }
                                                }
                                            }}>0</Button>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="mt-8 pt-6 border-t border-gray-100 flex flex-col items-center gap-4">
                                <button 
                                    onClick={() => setShowAdminLogin(true)}
                                    className="text-[10px] text-gray-400 hover:text-[#232F3E] font-bold uppercase tracking-widest flex items-center gap-1 transition-colors"
                                >
                                    <Settings className="w-3 h-3" />
                                    Mwen Se Mèt Magazen An
                                </button>
                                <button 
                                    onClick={handleLogout}
                                    className="text-[10px] text-red-400 hover:text-red-500 font-bold uppercase tracking-widest flex items-center gap-1 transition-colors"
                                >
                                    <LogOut className="w-3 h-3" />
                                    Dekonekte (Log Out)
                                </button>
                            </div>
                        </>
                    ) : (
                        <form onSubmit={handleAdminUnlock} className="space-y-4 animate-in fade-in zoom-in-95">
                            <div className="space-y-2 text-center mb-6">
                                <Label className="text-xs font-black uppercase tracking-widest text-gray-500">Paskod Mèt La</Label>
                                <Input 
                                    type="password" 
                                    value={adminPassword}
                                    onChange={(e) => setAdminPassword(e.target.value)}
                                    placeholder="Antre Paskod (Password) kont ou an..."
                                    className="h-14 bg-gray-50 text-center text-lg font-bold rounded-2xl"
                                    autoFocus
                                />
                            </div>
                            <Button disabled={adminLoginLoading} type="submit" className="w-full h-14 bg-[#232F3E] hover:bg-[#FF9900] text-white rounded-2xl font-black uppercase tracking-widest transition-all">
                                {adminLoginLoading ? <Loader2 className="w-5 h-5 animate-spin" /> : "KONTINYE"}
                            </Button>
                            <button 
                                type="button"
                                onClick={() => {setShowAdminLogin(false); setAdminPassword("");}}
                                className="w-full text-[10px] text-gray-400 font-bold uppercase tracking-widest mt-4 hover:underline"
                            >
                                Retounen nan lis kasye yo
                            </button>
                        </form>
                    )}
                </div>
            </div>
        );
    }

    return (
        <div className="flex bg-[#F8FAFC] min-h-screen font-['Inter', sans-serif]">
            {/* SIDEBAR - DESKTOP */}
            <aside className="hidden lg:flex w-72 bg-[#1E293B] flex-col sticky top-0 h-screen shadow-2xl z-[150] border-r border-white/5">
                <div className="p-10">
                    <h1 className="text-xl font-black italic tracking-tighter uppercase leading-none text-white flex items-center gap-3">
                        <div className="w-10 h-10 bg-[#FF9900] rounded-xl flex items-center justify-center shadow-lg shadow-orange-500/20 overflow-hidden shrink-0">
                            {seller?.logo ? (
                                <img src={seller.logo} alt="Logo" className="w-full h-full object-cover bg-white" />
                            ) : (
                                <Package className="w-6 h-6 text-white" />
                            )}
                        </div>
                        <span className="truncate max-w-[150px]">{seller?.store_name || "BVGLINK"}</span>
                    </h1>
                    <p className="text-[10px] font-black text-gray-500 uppercase tracking-[0.3em] mt-3 ml-1 opacity-50">MERCHANT DASHBOARD</p>
                </div>

                <nav className="flex-1 px-6 space-y-3 mt-4">
                    {[
                        { id: 'reports', icon: BarChart3, label: 'Rapò Biznis' },
                        { id: 'pos', icon: LayoutDashboard, label: 'POS Storefront' },
                        { id: 'products', icon: Package, label: 'Magazen ou' },
                        { id: 'orders', icon: ShoppingBag, label: 'Kòmand Yo' },
                        { id: 'list_requests', icon: Briefcase, label: 'Demann Lis' },
                        { id: 'wallet', icon: DollarSign, label: 'Bous ou' },
                        { id: 'location', icon: MapPin, label: 'Lokasyon Magazen' },
                    ].map((item) => {
                        if (activeCashier && item.id !== 'pos' && item.id !== 'orders' && item.id !== 'list_requests') return null;
                        return (
                        <button
                            key={item.id}
                            onClick={() => setActiveTab(item.id)}
                            className={`w-full h-14 rounded-2xl flex items-center gap-4 px-6 transition-all duration-300 group ${
                                activeTab === item.id 
                                ? 'bg-[#FF9900] text-white shadow-xl shadow-orange-500/20 scale-[1.02]' 
                                : 'text-gray-400 hover:bg-white/5 hover:text-white'
                            }`}
                        >
                            <item.icon className={`w-5 h-5 transition-transform duration-300 ${activeTab === item.id ? 'scale-110' : 'group-hover:scale-110'}`} />
                            <span className="text-xs font-black uppercase tracking-widest">{item.label}</span>
                        </button>
                    )})}
                </nav>

                <div className="p-8 mt-auto border-t border-white/5">
                    <div className="bg-white/5 rounded-3xl p-5 mb-6 border border-white/5">
                        <p className="text-[9px] font-black text-gray-500 uppercase tracking-widest mb-1">Apwobasyon</p>
                        <div className="flex items-center gap-2">
                            <div className={`w-2 h-2 rounded-full ${seller?.is_approved ? 'bg-green-500 shadow-[0_0_10px_rgba(34,197,94,0.5)]' : 'bg-red-500 shadow-[0_0_10px_rgba(239,68,68,0.5)]'}`} />
                            <span className={`text-[10px] font-black uppercase italic ${seller?.is_approved ? 'text-green-500' : 'text-red-500'}`}>
                                {seller?.is_approved ? 'Apwouve' : 'An Atant'}
                            </span>
                        </div>
                    </div>
                    {!activeCashier && (
                        <button 
                            onClick={() => {
                                setProfileData({
                                    store_name: seller?.store_name || "",
                                    phone: seller?.phone || "",
                                    address: seller?.address || "",
                                    logo: seller?.logo || "",
                                    cashiers: seller?.cashiers || []
                                });
                                setShowProfileModal(true);
                            }}
                            className="w-full h-14 rounded-2xl flex items-center gap-4 px-6 text-gray-400 hover:text-white hover:bg-white/5 transition-all group mb-2"
                        >
                            <Settings className="w-5 h-5 group-hover:rotate-45 transition-transform" />
                            <span className="text-xs font-black uppercase tracking-widest">Reglaj Magazen</span>
                        </button>
                    )}
                    <button 
                        onClick={handleLogout}
                        className="w-full h-14 rounded-2xl flex items-center gap-4 px-6 text-red-400/60 hover:text-red-400 hover:bg-red-500/5 transition-all group"
                    >
                        <LogOut className="w-5 h-5 group-hover:-translate-x-1 transition-transform" />
                        <span className="text-xs font-black uppercase tracking-widest">Dekonekte</span>
                    </button>
                </div>
            </aside>

            {/* MAIN CONTENT AREA */}
            <main className="flex-1 flex flex-col min-h-screen relative overflow-x-hidden bg-[#F8FAFC]">
                {/* HEADER - MOBILE & TOP NAV */}
                <header className="bg-white/80 backdrop-blur-xl border-b border-gray-100 sticky top-0 z-[100] px-4 py-4 sm:px-8 shadow-sm">
                    <div className="max-w-7xl mx-auto flex items-center justify-between">
                        <div className="flex items-center gap-4">
                            {/* Mobile Logo Only */}
                            <div className="lg:hidden flex flex-col">
                                <h1 className="text-xl font-black italic tracking-tighter uppercase leading-none text-[#232F3E]">
                                    Kont <span className="text-[#FF9900]">Machann</span>
                                </h1>
                            </div>
                            
                            <div className="hidden lg:flex items-center gap-4">
                                <div className={`flex items-center gap-2 px-4 py-2 rounded-full text-[9px] font-black uppercase tracking-widest transition-all ${isWakeLockActive ? 'bg-green-50 text-green-600 border border-green-100 shadow-sm' : 'bg-red-50 text-red-600 border border-red-100 shadow-sm'}`}>
                                    <div className={`w-2 h-2 rounded-full ${isWakeLockActive ? 'bg-green-600 animate-pulse' : 'bg-red-600'}`} />
                                    {isWakeLockActive ? 'Sistèm Limen' : 'Sistèm ap Dòmi'}
                                </div>
                                <div className="h-6 w-px bg-gray-200" />
                                <div className="flex items-center gap-2 text-gray-400 font-bold text-[9px] uppercase tracking-widest">
                                    <Clock className="w-3.5 h-3.5" /> {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                </div>
                            </div>
                        </div>

                        <div className="flex items-center gap-4">
                            {!activeCashier ? (
                            <>
                                {/* Wallet Quick Display */}
                                <div className="hidden md:flex flex-col items-end mr-6 group cursor-pointer" onClick={() => setActiveTab('wallet')}>
                                    <span className="text-[8px] font-black text-gray-400 uppercase tracking-[0.2em] group-hover:text-[#FF9900] transition-colors">Balans kounye a</span>
                                    <div className="flex items-baseline gap-1">
                                        <span className="text-xl font-black text-[#232F3E] italic group-hover:scale-105 transition-transform">{(wallet?.available_balance || 0).toLocaleString()}</span>
                                        <span className="text-[10px] font-black text-gray-400 uppercase tracking-widest">HTG</span>
                                    </div>
                                </div>

                                <div className="flex items-center gap-3">
                                    <Button
                                        onClick={() => !seller?.is_approved ? toast.error("Kont ou an poko apwouve.") : setShowAddModal(true)}
                                        className={`h-12 px-8 rounded-2xl font-black uppercase tracking-widest text-[10px] shadow-2xl transition-all hover:scale-105 active:scale-95 ${
                                            !seller?.is_approved ? 'bg-gray-100 text-gray-400 cursor-not-allowed shadow-none' : 'bg-[#FF9900] hover:bg-black text-white shadow-orange-500/20'
                                        }`}
                                    >
                                        <Plus className="w-5 h-5 mr-2" /> Poste Atik
                                    </Button>

                                    <div className="flex items-center gap-2 bg-gray-50/50 backdrop-blur-md rounded-2xl p-1.5 border border-gray-100 shadow-inner">
                                        <Button 
                                            variant="ghost" 
                                            size="icon"
                                            onClick={() => setIsSoundEnabled(!isSoundEnabled)}
                                            className={`h-10 w-10 rounded-xl transition-all ${isSoundEnabled ? 'bg-green-500/10 text-green-500 hover:bg-green-500 hover:text-white' : 'text-gray-300 hover:bg-gray-100'}`}
                                        >
                                            {isSoundEnabled ? <Volume2 className="w-4.5 h-4.5" /> : <VolumeX className="w-4.5 h-4.5" />}
                                        </Button>
                                        <Button 
                                            variant="ghost" 
                                            size="icon"
                                            onClick={() => { startAlarm(); requestWakeLock(); toast.success("Notifikasyon Verifye!"); }}
                                            className="h-10 w-10 rounded-xl text-[#FF9900] hover:bg-[#FF9900] hover:text-white transition-all"
                                        >
                                            <Bell className="w-4.5 h-4.5" />
                                        </Button>
                                    </div>
                                </div>
                            </>
                            ) : (
                                <div className="flex items-center gap-3">
                                    <div className="flex items-center gap-2 bg-gray-50/50 backdrop-blur-md rounded-2xl p-1.5 border border-gray-100 shadow-inner">
                                        <Button 
                                            variant="ghost" 
                                            size="icon"
                                            onClick={() => setIsSoundEnabled(!isSoundEnabled)}
                                            className={`h-10 w-10 rounded-xl transition-all ${isSoundEnabled ? 'bg-green-500/10 text-green-500 hover:bg-green-500 hover:text-white' : 'text-gray-300 hover:bg-gray-100'}`}
                                        >
                                            {isSoundEnabled ? <Volume2 className="w-4.5 h-4.5" /> : <VolumeX className="w-4.5 h-4.5" />}
                                        </Button>
                                        <Button 
                                            variant="ghost" 
                                            size="icon"
                                            onClick={() => { startAlarm(); requestWakeLock(); toast.success("Notifikasyon Verifye!"); }}
                                            className="h-10 w-10 rounded-xl text-[#FF9900] hover:bg-[#FF9900] hover:text-white transition-all"
                                        >
                                            <Bell className="w-4.5 h-4.5" />
                                        </Button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </header>

                <div className="flex-1 p-4 md:p-10 lg:p-12 overflow-y-auto w-full">
                    <div className="max-w-7xl mx-auto space-y-10">
                        {/* MOBILE TOP SETTINGS BAR IF NOT CASHIER */}
                        {!activeCashier && (
                            <div className="lg:hidden flex items-center justify-between gap-2 mb-2 -mt-4">
                                <button 
                                    onClick={handleLogout}
                                    className="flex items-center gap-2 px-4 py-2 bg-red-50 text-red-500 rounded-xl shadow-sm border border-red-100"
                                >
                                    <LogOut className="w-4 h-4" />
                                    <span className="text-[10px] font-black uppercase tracking-widest">Soti</span>
                                </button>
                                <button 
                                    onClick={() => {
                                        setProfileData({
                                            store_name: seller?.store_name || "",
                                            phone: seller?.phone || "",
                                            address: seller?.address || "",
                                            logo: seller?.logo || "",
                                            cashiers: seller?.cashiers || []
                                        });
                                        setShowProfileModal(true);
                                    }}
                                    className="flex items-center gap-2 px-4 py-2 bg-white rounded-xl shadow-sm border border-gray-100 text-[#FF9900]"
                                >
                                    <Settings className="w-4 h-4" />
                                    <span className="text-[10px] font-black uppercase tracking-widest">Reglaj / Kasye</span>
                                </button>
                            </div>
                        )}

                        {/* MOBILE TAB NAV */}
                        <div className="lg:hidden flex flex-wrap gap-2 pb-6 -mx-4 px-4 mb-4">
                            {[
                                { id: 'reports', icon: BarChart3, label: 'Rapò' },
                                { id: 'pos', icon: LayoutDashboard, label: 'POS' },
                                { id: 'products', icon: Package, label: 'Atik' },
                                { id: 'orders', icon: ShoppingBag, label: 'Kòmand' },
                                { id: 'list_requests', icon: Briefcase, label: 'Demann' },
                                { id: 'wallet', icon: DollarSign, label: 'Bous' },
                                { id: 'location', icon: MapPin, label: 'Lokasyon' },
                            ].map((tab) => {
                                if (activeCashier && tab.id !== 'pos' && tab.id !== 'orders' && tab.id !== 'list_requests') return null;
                                return (
                                <button
                                    key={tab.id}
                                    onClick={() => setActiveTab(tab.id)}
                                    className={`flex-1 min-w-[56px] h-14 rounded-2xl flex flex-col items-center justify-center transition-all ${
                                        activeTab === tab.id ? 'bg-[#232F3E] text-[#FF9900] shadow-xl' : 'bg-white text-gray-400 border border-gray-100'
                                    }`}
                                >
                                    <tab.icon className="w-5 h-5 mb-1" />
                                    <span className="text-[7px] font-black uppercase tracking-tighter">{tab.label}</span>
                                </button>
                            )})}
                        </div>

                {/* CONTENT AREA BASED ON TAB */}
                {activeTab === "pos" && (
                    <>
                    {/* Cashier Lock Screen logic moved globally. If this runs, it means they are logged in or admin. */}
                    {seller?.cashiers?.length > 0 && !activeCashier && (
                        <div className="flex flex-col items-center justify-center min-h-[50vh] animate-in zoom-in duration-300">
                             <div className="bg-white p-8 rounded-[40px] shadow-2xl max-w-sm w-full mx-auto border border-gray-100 flex flex-col items-center justify-center">
                                <h3 className="text-xl font-black text-center uppercase tracking-tighter italic mb-2">KASYE FÈMEN</h3>
                                <p className="text-[10px] text-gray-400 font-bold uppercase tracking-widest text-center mb-8">Switche sou yon kasye pou itilize kès la</p>

                                <Button 
                                    onClick={() => { setIsAdminUnlocked(false); }} 
                                    className="w-full h-12 bg-[#232F3E] hover:bg-[#FF9900] text-white rounded-xl font-black uppercase"
                                >
                                    <Lock className="w-4 h-4 mr-2" /> KANDENNA DASHBOARD LA
                                </Button>
                             </div>
                        </div>
                    )}
                    <div className="flex flex-col gap-6 animate-in fade-in slide-in-from-bottom duration-500 relative">
                        {activeCashier && (
                            <div className="absolute top-0 right-0 z-10 flex items-center bg-white border border-gray-100 rounded-full pr-1 pl-4 py-1 shadow-sm mt-2 lg:mt-0 mr-2 lg:mr-0 text-xs">
                                <span className="font-bold text-gray-500 uppercase tracking-widest text-[9px] mr-2">Kasye Actif:</span>
                                <span className="font-black text-[#232F3E] text-[10px] uppercase">{activeCashier.name}</span>
                                <button onClick={() => setActiveCashier(null)} className="ml-3 bg-red-100 text-red-600 rounded-full w-6 h-6 flex items-center justify-center hover:bg-red-500 hover:text-white transition-colors" title="Fèmen Kès La">
                                    <Lock className="w-3 h-3" />
                                </button>
                            </div>
                        )}
                        {/* Mobile Switcher */}
                        <div className="lg:hidden flex bg-white rounded-2xl p-1 shadow-sm border border-gray-100 mt-12 sm:mt-0">
                            <button 
                                onClick={() => setMobileTab("products")}
                                className={`flex-1 py-3 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all ${mobileTab === 'products' ? 'bg-[#FF9900] text-white' : 'text-gray-400'}`}
                            >
                                Katalog
                            </button>
                            <button 
                                onClick={() => setMobileTab("cart")}
                                className={`flex-1 py-3 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all relative ${mobileTab === 'cart' ? 'bg-[#FF9900] text-white' : 'text-gray-400'}`}
                            >
                                Panye
                                {posCart.length > 0 && (
                                    <span className="absolute top-1 right-2 w-4 h-4 bg-red-500 text-white rounded-full flex items-center justify-center text-[8px] border-2 border-white">
                                        {posCart.reduce((s,i) => s + i.qty, 0)}
                                    </span>
                                )}
                            </button>
                        </div>

                        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                            {/* Product Selection */}
                            <div className={`${mobileTab === 'products' ? 'block' : 'hidden lg:block'} lg:col-span-2 space-y-6`}>
                            <Card className="rounded-[40px] border-none shadow-2xl overflow-hidden bg-white">
                                <CardHeader className="p-8 border-b border-gray-50 flex flex-row items-center justify-between">
                                    <div className="flex flex-col">
                                        <CardTitle className="text-xl font-black text-gray-900 uppercase tracking-tighter italic flex items-center gap-3">
                                            <Tag className="w-5 h-5 text-[#FF9900]" /> Chwazi Pwodwi
                                        </CardTitle>
                                        <span className="text-[9px] font-black text-gray-400 uppercase tracking-widest mt-1">Multi-vendor POS Inventory</span>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <div className="relative">
                                            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-300" />
                                            <Input 
                                                placeholder="Chèche oswa Eskane..." 
                                                className="w-48 sm:w-64 h-10 pl-10 rounded-xl bg-gray-50 border-none text-[10px] font-bold"
                                                onKeyDown={(e) => {
                                                    if(e.key === 'Enter') {
                                                        const val = e.target.value.trim();
                                                        if (val) handleBarcodeResult(val, e.target);
                                                    }
                                                }}
                                                onChange={(e) => {
                                                    const val = e.target.value.toLowerCase();
                                                    const items = document.querySelectorAll('.pos-item');
                                                    items.forEach(item => {
                                                        const title = item.getAttribute('data-title').toLowerCase();
                                                        item.style.display = title.includes(val) ? 'block' : 'none';
                                                    });
                                                }}
                                            />
                                        </div>
                                        <Button
                                            variant="outline"
                                            size="icon"
                                            onClick={() => setShowScannerModal(true)}
                                            className="h-10 w-10 shrink-0 text-[#FF9900] bg-[#FF9900]/10 border-transparent hover:bg-[#FF9900] hover:text-white rounded-xl transition-colors"
                                        >
                                            <ScanLine className="w-5 h-5" />
                                        </Button>
                                        <Button
                                            onClick={() => setShowFastPosModal(true)}
                                            className="h-10 px-4 shrink-0 bg-[#232F3E] text-white hover:bg-[#FF9900] hover:text-black rounded-xl transition-colors text-[10px] font-black uppercase tracking-widest shadow-xl"
                                        >
                                            <Plus className="w-4 h-4 mr-1" /> Ajoute Item
                                        </Button>
                                    </div>
                                </CardHeader>
                                <CardContent className="p-8 max-h-[600px] overflow-y-auto no-scrollbar">
                                    <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-4 gap-4">
                                        {products.filter(p => p.is_active && (p.display_on === 'pos' || p.display_on === 'both')).map(product => (
                                            <button
                                                key={product.id}
                                                data-title={product.title}
                                                onClick={() => {
                                                    setPosCart(prev => {
                                                        const existing = prev.find(i => i.id === product.id);
                                                        if (existing) {
                                                            return prev.map(i => i.id === product.id ? { ...i, qty: i.qty + 1 } : i);
                                                        }
                                                        return [...prev, { ...product, qty: 1 }];
                                                    });
                                                    toast.success(`${product.title} ajoute nan panye`);
                                                }}
                                                className="pos-item group flex flex-col items-center p-4 bg-gray-50 hover:bg-[#232F3E] rounded-[25px] border border-gray-100 transition-all text-center relative"
                                            >
                                                <div className={`w-16 h-16 sm:w-20 sm:h-20 rounded-2xl mb-3 shadow-sm group-hover:scale-105 transition-transform flex items-center justify-center border border-gray-100/50 ${product.images?.[0] ? 'bg-white overflow-hidden' : getCategoryColor(product.category)}`}>
                                                    {product.images?.[0] ? (
                                                        <img src={product.images[0]} alt="" className="w-full h-full object-cover" />
                                                    ) : (
                                                        (() => {
                                                            const Icon = getCategoryIcon(product.category);
                                                            return <Icon className="w-8 h-8 mx-auto" />;
                                                        })()
                                                    )}
                                                </div>
                                                <p className="text-[10px] font-black text-gray-900 group-hover:text-white uppercase tracking-tighter line-clamp-2 leading-tight italic">{product.title}</p>
                                                <span className="text-[11px] font-black text-[#FF9900] mt-2 italic">{product.price_htg.toLocaleString()} HTG</span>
                                                <div className="absolute top-2 right-2 w-6 h-6 bg-[#FF9900] rounded-full flex items-center justify-center text-white text-xs opacity-0 group-hover:opacity-100 transition-opacity">
                                                    <Plus className="w-4 h-4" />
                                                </div>
                                            </button>
                                        ))}
                                    </div>
                                </CardContent>
                            </Card>
                            </div>

                            {/* POS Cart Sidebar */}
                            <div className={`${mobileTab === 'cart' ? 'block' : 'hidden lg:block'} space-y-6 lg:mt-0`}>
                            <Card className="rounded-[40px] border-none shadow-2xl overflow-hidden bg-[#232F3E] text-white sticky top-24">
                                <CardHeader className="p-8 border-b border-white/5">
                                    <CardTitle className="text-xl font-black uppercase tracking-tighter italic flex items-center justify-between">
                                        <span className="flex items-center gap-3"><ShoppingBag className="w-6 h-6 text-[#FF9900]" /> PANYE</span>
                                        <Button 
                                            variant="ghost" 
                                            size="sm" 
                                            onClick={() => setPosCart([])}
                                            className="text-[9px] font-black text-red-400 hover:bg-red-500/10 hover:text-red-300 uppercase tracking-widest"
                                        >
                                            <Trash2 className="w-3 h-3 mr-1" /> Vide panye
                                        </Button>
                                    </CardTitle>
                                </CardHeader>
                                <CardContent className="p-8">
                                    <div className="space-y-6 min-h-[200px] max-h-[400px] overflow-y-auto no-scrollbar mb-8">
                                        {posCart.length === 0 ? (
                                            <div className="text-center py-12 text-white/20 flex flex-col items-center">
                                                <ShoppingCart className="w-12 h-12 mb-4" />
                                                <p className="text-[10px] font-black uppercase tracking-widest">Panye a vid</p>
                                            </div>
                                        ) : (
                                            posCart.map(item => (
                                                <div key={item.id} className="flex items-center justify-between group animate-in slide-in-from-right duration-300">
                                                    <div className="flex items-center gap-4">
                                                        <div className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 border border-white/5 ${item.images?.[0] ? 'bg-white/10 overflow-hidden' : getCategoryColor(item.category)}`}>
                                                            {item.images?.[0] ? (
                                                                <img src={item.images[0]} alt="" className="w-full h-full object-cover" />
                                                            ) : (
                                                                (() => {
                                                                    const Icon = getCategoryIcon(item.category);
                                                                    return <Icon className="w-5 h-5 mx-auto" />;
                                                                })()
                                                            )}
                                                        </div>
                                                        <div className="flex flex-col">
                                                            <span className="text-[10px] font-black uppercase italic tracking-tighter line-clamp-1 w-24 sm:w-32">{item.title}</span>
                                                            <span className="text-[11px] font-black text-[#FF9900] italic">{item.price_htg.toLocaleString()} HTG</span>
                                                        </div>
                                                    </div>
                                                    <div className="flex items-center gap-3">
                                                        <div className="flex items-center bg-white/5 rounded-lg border border-white/10">
                                                            <button 
                                                                onClick={() => {
                                                                    if (item.qty <= 1) {
                                                                        setPosCart(prev => prev.filter(i => i.id !== item.id));
                                                                    } else {
                                                                        setPosCart(prev => prev.map(i => i.id === item.id ? { ...i, qty: i.qty - 1 } : i));
                                                                    }
                                                                }}
                                                                className="px-2 py-1 hover:text-red-400 transition-colors"
                                                            >-</button>
                                                            <span className="text-[10px] font-black px-2">{item.qty}</span>
                                                            <button 
                                                                onClick={() => { const p = products.find(prod => prod.id === item.id); if (p && item.qty >= (p.stock ?? 9999)) { toast.error('Pa gen ase estòk pou pwodwi sa a!'); return; } setPosCart(prev => prev.map(i => i.id === item.id ? { ...i, qty: i.qty + 1 } : i)); }}
                                                                className="px-2 py-1 hover:text-green-400 transition-colors"
                                                            >+</button>
                                                        </div>
                                                        <button 
                                                            onClick={() => setPosCart(prev => prev.filter(i => i.id !== item.id))}
                                                            className="text-white/20 hover:text-red-500 transition-colors"
                                                        >
                                                            <Trash className="w-4 h-4" />
                                                        </button>
                                                    </div>
                                                </div>
                                            ))
                                        )}
                                    </div>

                                    <div className="space-y-4 pt-6 border-t border-white/5">
                                        {/* Buyer Identification */}
                                        <div className="space-y-2">
                                            <label className="text-[9px] font-black text-white/40 uppercase tracking-widest">NIMERO TELEFÒN KLIYAN (OBLIGATWA)</label>
                                            <div className="relative">
                                                <Smartphone className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#FF9900]" />
                                                <Input 
                                                    value={posBuyerPhone}
                                                    onChange={(e) => setPosBuyerPhone(e.target.value)}
                                                    placeholder="Egz: 5093xxxxxxx"
                                                    className="h-12 pl-10 rounded-xl bg-white/5 border-white/10 text-white font-bold text-xs"
                                                />
                                            </div>
                                        </div>

                                        <div className="flex justify-between items-end pt-4">
                                            <div className="flex flex-col gap-0.5">
                                                <span className="text-[10px] font-black text-white/40 uppercase tracking-widest">TOTAL POU PEYE</span>
                                                {posDeliveryEnabled && posDeliveryKm && parseFloat(posDeliveryKm) > 0 && (
                                                    <span className="text-[8px] text-[#FF9900]/70 font-bold">Enkli tra transpò +{(parseFloat(posDeliveryKm) * 25).toLocaleString()} HTG</span>
                                                )}
                                            </div>
                                            <span className="text-3xl font-black text-[#FF9900] italic tracking-tighter">
                                                {(posCart.reduce((sum, item) => sum + (item.price_htg * item.qty), 0) + (posDeliveryEnabled && posDeliveryKm ? parseFloat(posDeliveryKm) * 25 : 0)).toLocaleString()} <span className="text-[10px]">HTG</span>
                                            </span>
                                        </div>
                                        
                                        <div className="grid grid-cols-2 gap-3 pt-4">
                                            <Button
                                                disabled={!posBuyerPhone || posCart.length === 0}
                                                onClick={async () => {
                                                    if (posCart.length === 0) return toast.error("Panye a vid!");
                                                    if (!posBuyerPhone) return toast.error("Tanpri antre nimewo kliyan an!");
                                                    const deliveryFee = posDeliveryEnabled && posDeliveryKm ? parseFloat(posDeliveryKm) * 25 : 0;
                                                    const total = posCart.reduce((sum, item) => sum + (item.price_htg * item.qty), 0) + deliveryFee;
                                                    const cashierName = activeCashier ? activeCashier.name : "Pwopriyet\u00e8";
                                                    try {
                                                        const token = localStorage.getItem("seller_token");
                                                        const pbx = await axios.post(`${API}/marketplace/orders`, {
                                                            buyer_name: "Kliyan POS",
                                                            buyer_phone: posBuyerPhone,
                                                            delivery_address: posDeliveryEnabled && posDeliveryAddress ? posDeliveryAddress : "Anndan Magazen",
                                                            seller_id: seller?.id || seller?._id,
                                                            items: posCart.map(item => ({
                                                                product_id: item.id,
                                                                product_title: item.title,
                                                                price: item.price_htg,
                                                                quantity: item.qty
                                                            })),
                                                            total_htg: total,
                                                            payment_method: "moncash",
                                                            delivery_method: posDeliveryEnabled ? "delivery" : "pickup",
                                                            cashier_name: cashierName
                                                        }, { headers: { Authorization: `Bearer ${token}` } });
                                                        if (posDeliveryEnabled && posDeliveryKm) {
                                                            try {
                                                                await axios.post(`${API}/marketplace/orders/${pbx.data.order_id}/request-delivery`, {
                                                                    distance_km: parseFloat(posDeliveryKm)
                                                                }, { headers: { Authorization: `Bearer ${token}` } });
                                                                toast.success("Komand MonCash kreye! Demann livrezon voye bay chofè yo.");
                                                            } catch {
                                                                toast.info("Komand kreye. Al nan Komand yo pou mande chofè manyelman.");
                                                            }
                                                        } else {
                                                            toast.success("Komand MonCash #" + pbx.data.order_id + " kreye pou " + posBuyerPhone);
                                                        }
                                                        setPosCart([]);
                                                        setPosBuyerPhone("");
                                                        setPosDeliveryEnabled(false);
                                                        setPosDeliveryAddress("");
                                                        setPosDeliveryKm("");
                                                        fetchInitialData();
                                                    } catch (err) {
                                                        toast.error(err.response?.data?.detail || "Echek nan kreye komand MonCash.");
                                                    }
                                                }}
                                                className="bg-[#FF9900] hover:bg-white hover:text-black text-white font-black h-14 rounded-2xl text-[10px] uppercase tracking-widest shadow-2xl transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                                            >
                                                <CreditCard className="w-4 h-4 mr-2" /> MonCash
                                            </Button>
                                            <Button
                                                disabled={!posBuyerPhone || posCart.length === 0}
                                                onClick={() => {
                                                    if (posCart.length === 0) return toast.error("Panye a vid!");
                                                    if (!posBuyerPhone) return toast.error("Tanpri antre nimewo kliyan an!");
                                                    setAmountTendered("");
                                                    setShowCashCalculatorModal(true);
                                                }}
                                                className="bg-white/10 hover:bg-white hover:text-black text-white font-black h-14 rounded-2xl text-[10px] uppercase tracking-widest border border-white/10 disabled:opacity-50"
                                            >
                                                <DollarSign className="w-4 h-4 mr-2" /> Kach (Cash)
                                            </Button>
                                        </div>
                                        
                                        <button
                                            type="button"
                                            disabled={posCart.length === 0}
                                            onClick={() => {
                                                if (posCart.length === 0) return toast.error("Panye a vid!");
                                                setPosDeliveryEnabled(prev => !prev);
                                                if (posDeliveryEnabled) {
                                                    setPosDeliveryAddress("");
                                                    setPosDeliveryKm("");
                                                }
                                            }}
                                            className={`w-full h-12 rounded-2xl text-[9px] font-black uppercase tracking-widest transition-all flex items-center justify-center gap-2 border disabled:opacity-30 disabled:cursor-not-allowed ${
                                                posDeliveryEnabled
                                                    ? "bg-[#FF9900]/20 border-[#FF9900] text-[#FF9900]"
                                                    : "bg-transparent border-white/10 text-white/40 hover:bg-white/5"
                                            }`}
                                        >
                                            <MapPin className="w-4 h-4" />
                                            {posDeliveryEnabled ? "Siprime Livrezon" : "Ajoute Livrezon"}
                                        </button>

                                        {/* Inline Delivery Form */}
                                        {posDeliveryEnabled && (
                                            <div className="space-y-3 animate-in fade-in slide-in-from-top-3 duration-300 bg-white/5 rounded-2xl p-4 border border-[#FF9900]/30">
                                                <p className="text-[9px] font-black text-[#FF9900] uppercase tracking-widest flex items-center gap-1">
                                                    <MapPin className="w-3 h-3" /> Livrezon Kliyan
                                                </p>

                                                <div className="space-y-1">
                                                    <label className="text-[8px] font-black text-white/40 uppercase tracking-widest">Adwes Livrezon</label>
                                                    <input
                                                        type="text"
                                                        placeholder="Egz: #14 Delma 33, Potoprens"
                                                        value={posDeliveryAddress}
                                                        onChange={e => setPosDeliveryAddress(e.target.value)}
                                                        className="w-full h-10 rounded-xl bg-white/10 border border-white/10 text-white placeholder:text-white/20 font-bold text-xs px-3 focus:outline-none focus:border-[#FF9900]/60"
                                                    />
                                                </div>

                                                <div className="space-y-1">
                                                    <label className="text-[8px] font-black text-white/40 uppercase tracking-widest">Distans (KM) — 25 HTG/KM</label>
                                                    <div className="relative">
                                                        <input
                                                            type="number"
                                                            min="0"
                                                            step="0.5"
                                                            placeholder="Egz: 3.5"
                                                            value={posDeliveryKm}
                                                            onChange={e => setPosDeliveryKm(e.target.value)}
                                                            className="w-full h-10 rounded-xl bg-white/10 border border-white/10 text-white placeholder:text-white/20 font-bold text-xs px-3 pr-12 focus:outline-none focus:border-[#FF9900]/60"
                                                        />
                                                        <span className="absolute right-3 top-1/2 -translate-y-1/2 text-[9px] font-black text-white/30">KM</span>
                                                    </div>
                                                </div>

                                                {posDeliveryKm && parseFloat(posDeliveryKm) > 0 && (
                                                    <div className="flex justify-between items-center px-3 py-2 bg-[#FF9900]/10 rounded-xl border border-[#FF9900]/20 animate-in fade-in duration-300">
                                                        <span className="text-[8px] font-black text-[#FF9900] uppercase tracking-widest">Fra Transpo</span>
                                                        <span className="text-sm font-black text-[#FF9900] italic">+{(parseFloat(posDeliveryKm) * 25).toLocaleString()} HTG</span>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </CardContent>
                            </Card>
                        </div>
                    </div>
                </div>
            </>
        )}


                {activeTab === "products" && (
                     <Card className="rounded-[50px] border-none shadow-2xl overflow-hidden bg-white">
                        <CardHeader className="p-10 border-b border-gray-50 flex flex-row items-center justify-between">
                            <CardTitle className="text-2xl font-black text-gray-900 uppercase tracking-tighter italic flex items-center gap-3">
                                <Briefcase className="w-6 h-6 text-[#FF9900]" /> Magazen ou
                            </CardTitle>
                            <div 
                                className="h-10 w-10 bg-gray-50 rounded-xl flex items-center justify-center text-gray-300 hover:text-blue-500 hover:bg-blue-50 cursor-pointer transition-colors"
                                onClick={handleOpenProfile}
                            >
                                <Settings className="w-5 h-5" />
                            </div>
                        </CardHeader>
                        <CardContent className="p-0">
                            {loading ? (
                                <div className="p-32 text-center text-gray-400 flex flex-col items-center gap-6">
                                    <Loader2 className="w-12 h-12 animate-spin text-[#FF9900]" />
                                    <p className="font-black uppercase tracking-widest text-xs">Ap chaje done machann ou...</p>
                                </div>
                            ) : products.length > 0 ? (
                                <div className="overflow-x-auto">
                                    {/* Desktop Table */}
                                    <table className="w-full hidden md:table">
                                        <thead className="bg-gray-50/50 text-gray-300 text-left">
                                            <tr>
                                                <th className="px-10 py-6 text-[10px] font-black uppercase tracking-[0.2em]">Pwodwi Detay</th>
                                                <th className="px-8 py-6 text-[10px] font-black uppercase tracking-[0.2em]">Depatman</th>
                                                <th className="px-8 py-6 text-[10px] font-black uppercase tracking-[0.2em]">Pri Vant</th>
                                                <th className="px-8 py-6 text-[10px] font-black uppercase tracking-[0.2em] text-center">Jere</th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-50">
                                            {products.map((product) => (
                                                <tr key={product.id} className="hover:bg-gray-50/50 transition-all group">
                                                    <td className="px-10 py-6">
                                                        <div className="flex items-center gap-6">
                                                            <div className="w-20 h-20 bg-gray-50 rounded-[25px] overflow-hidden flex items-center justify-center border border-gray-100 relative shrink-0 shadow-sm">
                                                                {product.images?.[0] ? (
                                                                    <img src={product.images[0]} alt="" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                                                                ) : (
                                                                    <Package className="w-8 h-8 text-gray-200" />
                                                                )}
                                                                {!product.is_active && (
                                                                    <div className="absolute inset-0 bg-black/60 flex items-center justify-center text-[8px] text-white font-black uppercase tracking-widest">SISPANN</div>
                                                                )}
                                                            </div>
                                                            <div>
                                                                <p className="font-black text-lg text-gray-900 line-clamp-1 group-hover:text-[#FF9900] transition-colors tracking-tight">{product.title}</p>
                                                                <div className="flex items-center gap-3 mt-1.5">
                                                                    <span className="text-[10px] font-black text-gray-300 uppercase tracking-widest">Tip: <span className="text-gray-500">{product.type}</span></span>
                                                                    <div className="h-1 w-1 bg-gray-200 rounded-full"></div>
                                                                    <span className="text-[10px] font-black text-gray-300 uppercase tracking-widest">Kondisyon: <span className="text-gray-500">{product.condition}</span></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="px-8 py-6">
                                                        <div className="flex flex-col gap-1">
                                                            <div className={`px-3 py-1 rounded-full text-[8px] font-black uppercase tracking-widest text-white inline-block w-fit ${product.is_active ? 'bg-green-500' : 'bg-red-500'}`}>
                                                                {product.is_active ? 'Online' : 'Off'}
                                                            </div>
                                                            <div className={`px-3 py-1 rounded-full text-[8px] font-black uppercase tracking-widest inline-block w-fit bg-gray-100 text-gray-500 border border-gray-200`}>
                                                                {product.display_on === 'pos' ? 'POS' : product.display_on === 'both' ? 'Tou de' : 'Market'}
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="px-8 py-6">
                                                        <div className="flex flex-col">
                                                            <span className="text-xl font-black text-gray-900 tracking-tighter leading-none">{product.price_htg.toLocaleString()} <span className="text-[10px] text-gray-400 font-bold ml-0.5">HTG</span></span>
                                                        </div>
                                                    </td>
                                                    <td className="px-8 py-6">
                                                        <div className="flex items-center justify-center gap-4">
                                                            <Button
                                                                variant="ghost"
                                                                title="We Sou Sit La"
                                                                className="w-12 h-12 p-0 rounded-2xl bg-gray-50 text-gray-400 hover:bg-[#232F3E] hover:text-white transition-all shadow-sm"
                                                                onClick={() => window.open(`/marketplace`, '_blank')}
                                                            >
                                                                <ExternalLink className="w-5 h-5" />
                                                            </Button>
                                                            <Button
                                                                variant="ghost"
                                                                title="Modifye"
                                                                className="w-12 h-12 p-0 rounded-2xl bg-blue-50 text-blue-500 hover:bg-blue-500 hover:text-white transition-all shadow-sm"
                                                                onClick={() => handleEditClick(product)}
                                                            >
                                                                <Edit className="w-5 h-5" />
                                                            </Button>
                                                            <Button
                                                                variant="ghost"
                                                                title="Efase"
                                                                className="w-12 h-12 p-0 rounded-2xl bg-red-50 text-red-500 hover:bg-red-500 hover:text-white transition-all shadow-md"
                                                                onClick={() => handleDelete(product.id)}
                                                            >
                                                                <Trash2 className="w-5 h-5" />
                                                            </Button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                    {/* Mobile Cards */}
                                    <div className="md:hidden flex flex-col divide-y divide-gray-100">
                                        {products.map((product) => (
                                            <div key={product.id} className="p-6 space-y-4">
                                                <div className="flex gap-4">
                                                    <div className="w-20 h-20 bg-gray-50 rounded-2xl overflow-hidden shrink-0 border border-gray-100 relative">
                                                        {product.images?.[0] ? (
                                                            <img src={product.images[0]} alt="" className="w-full h-full object-cover" />
                                                        ) : (
                                                            <div className="w-full h-full flex items-center justify-center"><Package className="w-6 h-6 text-gray-200" /></div>
                                                        )}
                                                        {!product.is_active && (
                                                            <div className="absolute inset-0 bg-black/60 flex items-center justify-center text-[7px] text-white font-black uppercase tracking-widest">SISPANN</div>
                                                        )}
                                                    </div>
                                                    <div className="flex-1 min-w-0">
                                                        <p className="font-black text-gray-900 leading-tight line-clamp-2 uppercase italic tracking-tighter text-sm">{product.title}</p>
                                                        <div className="mt-2 flex flex-wrap gap-2">
                                                            <span className="text-[8px] font-black uppercase tracking-widest px-2 py-1 bg-gray-50 border border-gray-100 rounded-lg text-gray-400 italic">
                                                                {categories.find(c => c.id === product.category)?.name || product.category}
                                                            </span>
                                                            <span className="text-[14px] font-black text-[#FF9900] italic tracking-tighter self-center">
                                                                {product.price_htg.toLocaleString()} HTG
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="flex gap-2 pt-2">
                                                    <Button
                                                        variant="ghost"
                                                        className="flex-1 h-12 rounded-xl bg-gray-50 text-gray-400 text-[9px] font-black uppercase tracking-widest"
                                                        onClick={() => window.open(`/marketplace`, '_blank')}
                                                    >
                                                        <Eye className="w-4 h-4 mr-2" /> Gade
                                                    </Button>
                                                    <Button
                                                        variant="ghost"
                                                        className="flex-1 h-12 rounded-xl bg-blue-50 text-blue-500 text-[9px] font-black uppercase tracking-widest"
                                                        onClick={() => handleEditClick(product)}
                                                    >
                                                        <Edit className="w-4 h-4 mr-2" /> Modifye
                                                    </Button>
                                                    <Button
                                                        variant="ghost"
                                                        className="flex-1 h-12 rounded-xl bg-red-50 text-red-500 text-[9px] font-black uppercase tracking-widest"
                                                        onClick={() => handleDelete(product.id)}
                                                    >
                                                        <Trash2 className="w-4 h-4 mr-2" /> Efase
                                                    </Button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ) : (
                                <div className="p-10 md:p-32 text-center flex flex-col items-center">
                                    <div className="w-20 h-20 md:w-24 md:h-24 bg-gray-50 rounded-[35px] md:rounded-[40px] flex items-center justify-center mx-auto mb-6 md:mb-8 text-gray-100 italic">
                                        <ShoppingBag className="w-10 h-10 md:w-12 md:h-12" />
                                    </div>
                                    <h3 className="text-xl md:text-2xl font-black text-gray-900 mb-4 tracking-tighter italic leading-none">Ou poko kòmanse vann anyen?</h3>
                                    <p className="text-gray-400 text-[9px] md:text-[10px] font-black uppercase tracking-[0.2em] mb-8 md:mb-12 max-w-xs mx-auto leading-loose">Pwofite 10,000+ kliyan sou sit la kounye a.</p>
                                    <Button
                                        onClick={() => setShowAddModal(true)}
                                        className="bg-[#232F3E] hover:bg-black text-white h-12 md:h-16 px-6 md:px-12 rounded-xl md:rounded-[25px] font-black text-xs md:text-lg transition-all hover:scale-105 shadow-2xl shadow-[#232F3E]/20 uppercase tracking-tight flex items-center justify-center gap-2 mx-auto"
                                    >
                                        <span className="hidden sm:inline">Poste Premye Pwodwi w la</span>
                                        <span className="sm:hidden">Poste yon pwodwi</span>
                                        <ChevronRight className="w-4 h-4 md:w-6 md:h-6 text-[#FF9900]" />
                                    </Button>
                                </div>
                            )}
                        </CardContent>
                    </Card>
                )}

                {activeTab === "orders" && (
                    <Card className="rounded-[50px] border-none shadow-2xl overflow-hidden bg-white">
                        <CardHeader className="p-10 border-b border-gray-50 flex flex-row items-center justify-between bg-blue-50/30">
                            <CardTitle className="text-2xl font-black text-gray-900 uppercase tracking-tighter italic flex items-center gap-3">
                                <ShoppingBag className="w-6 h-6 text-blue-600" /> Kòmand Yo
                            </CardTitle>
                            <span className="bg-blue-600 text-white px-4 py-2 rounded-xl text-[10px] font-black uppercase tracking-widest shadow-lg shadow-blue-200">
                                {orders.length} TOTAL
                            </span>
                        </CardHeader>
                        <CardContent className="p-0">
                            {orders.length > 0 ? (
                                <div className="overflow-x-auto min-h-[300px]">
                                    {/* Desktop Table */}
                                    <table className="w-full hidden md:table">
                                        <thead className="bg-gray-50/50 text-gray-300 text-left">
                                            <tr>
                                                <th className="px-10 py-6 text-[10px] font-black uppercase tracking-[0.2em]">Pwodwi achte</th>
                                                <th className="px-8 py-6 text-[10px] font-black uppercase tracking-[0.2em]">Kliyan</th>
                                                <th className="px-8 py-6 text-[10px] font-black uppercase tracking-[0.2em]">Pri</th>
                                                <th className="px-8 py-6 text-[10px] font-black uppercase tracking-[0.2em]">Estati</th>
                                                <th className="px-8 py-6 text-[10px] font-black uppercase tracking-[0.2em] text-center">Aksyon</th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-50">
                                            {orders.map((order) => (
                                                <tr key={order.id} className="hover:bg-gray-50/50 transition-all border-b border-gray-50">
                                                    <td className="px-10 py-6">
                                                        <div className="flex flex-col">
                                                            <span className="font-black text-gray-900 tracking-tight">{order.product_title}</span>
                                                            <div className="flex items-center gap-2">
                                                                <span className="text-[9px] text-gray-400 font-bold uppercase tracking-widest">ID: {order.id.slice(0, 8)}</span>
                                                                {order.transaction_id && (
                                                                    <span className="text-[9px] text-green-600 bg-green-50 px-1.5 py-0.5 rounded-sm font-bold uppercase tracking-widest">TX: {order.transaction_id}</span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="px-8 py-6">
                                                        <div className="flex flex-col">
                                                            <span className="font-bold text-gray-600">{order.buyer_phone}</span>
                                                            {order.payment_method === 'cash' && order.cashier_name && (
                                                                <span className="text-[9px] text-[#FF9900] font-black uppercase mt-1">KASYE: {order.cashier_name}</span>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td className="px-8 py-6">
                                                        <span className="text-lg font-black text-gray-900 italic tracking-tighter">{(order.seller_amount_htg || 0).toLocaleString()} <span className="text-[9px] text-gray-400 font-bold">HTG</span></span>
                                                    </td>
                                                    <td className="px-8 py-6">
                                                        <span className={`px-4 py-1.5 rounded-xl text-[9px] font-black uppercase tracking-widest shadow-sm ${
                                                            order.payment_status === 'completed' 
                                                            ? 'bg-green-500 text-white shadow-green-100' 
                                                            : 'bg-amber-500 text-white shadow-amber-100'
                                                        }`}>
                                                            {order.payment_status === 'completed' ? 'Peye' : 'An Atant'}
                                                        </span>
                                                    </td>
                                                    <td className="px-8 py-6">
                                                        <div className="flex items-center justify-center gap-3">
                                                            <Button
                                                                onClick={() => handlePrintReceipt(order)}
                                                                className="h-10 px-4 rounded-xl bg-gray-100 hover:bg-gray-200 text-gray-700 shadow-sm transition-all"
                                                                title="Enprime Resi"
                                                            >
                                                                <Printer className="w-4 h-4" />
                                                            </Button>
                                                            {order.payment_status === 'pending' && (
                                                                <Button
                                                                    onClick={() => handleVerifyPayment(order.id)}
                                                                    className="h-10 px-6 rounded-xl bg-blue-600 hover:bg-black text-white text-[9px] font-black uppercase tracking-widest shadow-xl shadow-blue-200 transition-all"
                                                                >
                                                                    Verifye
                                                                </Button>
                                                            )}
                                                            {order.payment_status === 'completed' && (
                                                                <>
                                                                    {/* New Flow: Preparing -> Ready -> Driver Request */}
                                                                    {(order.delivery_info?.status === 'pending' || !order.delivery_info?.status) && (
                                                                        <Button
                                                                            onClick={() => handleUpdateOrderStatus(order.id, 'preparing')}
                                                                            className="h-10 px-6 rounded-xl bg-gray-900 hover:bg-[#FF9900] text-white text-[9px] font-black uppercase tracking-widest shadow-xl transition-all"
                                                                        >
                                                                            Prepare Kòmand
                                                                        </Button>
                                                                    )}
                                                                    {order.delivery_info?.status === 'preparing' && (
                                                                        <Button
                                                                            onClick={() => handleUpdateOrderStatus(order.id, 'ready')}
                                                                            className="h-10 px-6 rounded-xl bg-green-600 hover:bg-black text-white text-[9px] font-black uppercase tracking-widest shadow-xl transition-all"
                                                                        >
                                                                            Voye l Pare
                                                                        </Button>
                                                                    )}
                                                                    {order.delivery_info?.status === 'ready' && order.delivery_info?.type === 'delivery' && (
                                                                        <Button
                                                                            onClick={() => {
                                                                                setSelectedOrder(order);
                                                                                setShowDeliveryModal(true);
                                                                            }}
                                                                            className="h-10 px-6 rounded-xl bg-[#FF9900] hover:bg-black text-white text-[9px] font-black uppercase tracking-widest shadow-xl transition-all flex items-center gap-2 animate-bounce"
                                                                        >
                                                                            <MapPin className="w-4 h-4" /> Mande Chofè
                                                                        </Button>
                                                                    )}
                                                                    {['accepted', 'picked_up', 'on_the_way', 'delivered'].includes(order.delivery_info?.status) && (
                                                                        <div className="flex items-center gap-4 bg-gray-50/80 p-4 rounded-[22px] border border-gray-100 shadow-sm min-w-[200px]">
                                                                            <div className="relative">
                                                                                <div className="w-12 h-12 rounded-full overflow-hidden bg-gray-200 border-2 border-white shadow-md">
                                                                                    {order.delivery_info?.driver_photo ? (
                                                                                        <img src={order.delivery_info.driver_photo} alt="Driver" className="w-full h-full object-cover" />
                                                                                    ) : (
                                                                                        <div className="w-full h-full flex items-center justify-center bg-[#232F3E] text-white font-black text-xs">
                                                                                            {order.delivery_info?.driver_name?.[0] || 'D'}
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                                {order.delivery_info?.status === 'delivered' ? (
                                                                                    <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-green-500 rounded-full border-2 border-white flex items-center justify-center">
                                                                                        <Check className="w-3 h-3 text-white" />
                                                                                    </div>
                                                                                ) : (
                                                                                    <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-blue-500 rounded-full border-2 border-white flex items-center justify-center">
                                                                                        <div className="w-1.5 h-1.5 bg-white rounded-full animate-pulse" />
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                            <div className="flex flex-col text-left">
                                                                                <span className="text-[11px] font-black text-gray-900 leading-none mb-1 tracking-tight truncate max-w-[120px]">
                                                                                    {order.delivery_info?.driver_name}
                                                                                </span>
                                                                                <div className="flex items-center gap-1.5">
                                                                                    <span className="text-[8px] font-black text-[#FF9900] uppercase tracking-widest bg-[#FF9900]/10 px-1.5 py-0.5 rounded-md leading-none">
                                                                                        {order.delivery_info?.vehicle_info?.split(' - ')[0] || 'Chofè'}
                                                                                    </span>
                                                                                    <span className="text-[9px] font-bold text-gray-400 leading-none">
                                                                                        {order.delivery_info?.driver_phone}
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                    {order.delivery_info?.type === 'pickup' && order.delivery_info?.status === 'ready' && (
                                                                        <div className="flex flex-col items-center">
                                                                            <span className="text-[8px] font-black uppercase text-green-500 mb-1 italic">Pare pou Pickup</span>
                                                                            <div className="w-10 h-10 rounded-full bg-green-50 flex items-center justify-center text-green-500 border border-green-100">
                                                                                <ShoppingBag className="w-5 h-5" />
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                    {/* Mobile Cards */}
                                    <div className="md:hidden flex flex-col divide-y divide-gray-100">
                                        {orders.map((order) => (
                                            <div key={order.id} className="p-6 space-y-4">
                                                <div className="flex justify-between items-start">
                                                    <div>
                                                        <h4 className="font-black text-gray-900 line-clamp-1 uppercase tracking-tighter text-sm italic">{order.product_title}</h4>
                                                        <div className="flex items-center gap-2 mt-0.5">
                                                            <p className="text-[10px] text-gray-400 font-bold">ID: {order.id.slice(0, 8)}</p>
                                                            {order.transaction_id && (
                                                                <span className="text-[9px] text-green-600 bg-green-50 px-1.5 py-0.5 rounded-sm font-bold uppercase tracking-widest">TX: {order.transaction_id}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <span className={`px-3 py-1 rounded-lg text-[8px] font-black uppercase tracking-widest ${
                                                        order.payment_status === 'completed' ? 'bg-green-500 text-white' : 'bg-amber-500 text-white'
                                                    }`}>
                                                        {order.payment_status === 'completed' ? 'Peye' : 'An Atant'}
                                                    </span>
                                                </div>
                                                <div className="grid grid-cols-2 gap-4 py-2 border-y border-gray-50 border-dashed">
                                                    <div>
                                                        <p className="text-[8px] font-black text-gray-300 uppercase tracking-widest mb-1">Kliyan</p>
                                                        <p className="text-[11px] font-bold text-gray-700">{order.buyer_phone}</p>
                                                        {order.payment_method === 'cash' && order.cashier_name && (
                                                            <p className="text-[9px] text-[#FF9900] font-black uppercase mt-1">KASYE: {order.cashier_name}</p>
                                                        )}
                                                    </div>
                                                    <div>
                                                        <p className="text-[8px] font-black text-gray-300 uppercase tracking-widest mb-1">Total</p>
                                                        <p className="text-[13px] font-black text-gray-900 italic">{(order.seller_amount_htg || order.total_htg || 0).toLocaleString()} HTG</p>
                                                    </div>
                                                </div>
                                                <div className="pt-2 flex flex-col">
                                                    {order.payment_status === 'pending' ? (
                                                        <Button
                                                            onClick={() => handleVerifyPayment(order.id)}
                                                            className="w-full h-12 rounded-xl bg-blue-600 text-white text-[10px] font-black uppercase tracking-widest shadow-lg shadow-blue-100"
                                                        >
                                                            Verifye Peman
                                                        </Button>
                                                    ) : (
                                                        <div className="flex flex-col gap-3">
                                                            <div className="flex items-center justify-between bg-gray-50 p-3 rounded-2xl">
                                                                <div className="flex flex-col">
                                                                    <span className="text-[8px] font-black text-gray-400 uppercase tracking-widest">Estati</span>
                                                                    <span className="text-[10px] font-black text-[#FF9900] uppercase italic">
                                                                        {order.delivery_info?.status?.replace('_', ' ') || 'Pending'}
                                                                    </span>
                                                                </div>
                                                                <span className="text-[9px] font-black text-gray-400 uppercase tracking-widest">{order.delivery_info?.type}</span>
                                                            </div>
                                                            
                                                            {/* Mobile Driver Info */}
                                                            {['accepted', 'picked_up', 'delivered'].includes(order.delivery_info?.status) && (
                                                                <div className="flex items-center gap-3 bg-white p-4 rounded-2xl border border-gray-100 shadow-sm mb-2">
                                                                    <div className="w-12 h-12 rounded-full overflow-hidden bg-gray-100 shrink-0 border-2 border-white shadow-sm">
                                                                        {order.delivery_info?.driver_photo ? (
                                                                            <img src={order.delivery_info.driver_photo} alt="Driver" className="w-full h-full object-cover" />
                                                                        ) : (
                                                                            <div className="w-full h-full flex items-center justify-center bg-[#232F3E] text-white font-black text-[10px]">
                                                                                {order.delivery_info?.driver_name?.[0] || 'D'}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    <div className="flex-1 flex flex-col min-w-0">
                                                                        <div className="flex items-center justify-between gap-2">
                                                                            <span className="text-xs font-black text-gray-900 truncate">{order.delivery_info?.driver_name}</span>
                                                                            <span className="bg-green-500/10 text-green-600 text-[7px] font-black px-1.5 py-0.5 rounded uppercase tracking-widest shrink-0">Chofè</span>
                                                                        </div>
                                                                        <div className="flex items-center gap-2 mt-1">
                                                                            <span className="text-[9px] font-bold text-gray-400">{order.delivery_info?.driver_phone}</span>
                                                                            <span className="w-1 h-1 bg-gray-200 rounded-full" />
                                                                            <span className="text-[9px] font-bold text-[#FF9900] uppercase">{order.delivery_info?.vehicle_info?.split(' - ')[0]}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            
                                                            {/* Mobile Actions */}
                                                            <Button
                                                                onClick={() => handlePrintReceipt(order)}
                                                                className="w-full h-12 rounded-xl bg-gray-100 text-gray-700 text-[10px] font-black uppercase tracking-widest shadow-sm mb-2"
                                                            >
                                                                <Printer className="w-4 h-4 mr-2" /> Enprime Resi
                                                            </Button>
                                                            {(order.delivery_info?.status === 'pending' || !order.delivery_info?.status) && (
                                                                <Button
                                                                    onClick={() => handleUpdateOrderStatus(order.id, 'preparing')}
                                                                    className="w-full h-12 rounded-xl bg-gray-900 text-white text-[10px] font-black uppercase tracking-widest shadow-xl"
                                                                >
                                                                    Prepare Kòmand la
                                                                </Button>
                                                            )}
                                                            {order.delivery_info?.status === 'preparing' && (
                                                                <Button
                                                                    onClick={() => handleUpdateOrderStatus(order.id, 'ready')}
                                                                    className="w-full h-12 rounded-xl bg-green-600 text-white text-[10px] font-black uppercase tracking-widest shadow-xl"
                                                                >
                                                                    Voye l Pare kounye a
                                                                </Button>
                                                            )}
                                                            {order.delivery_info?.status === 'ready' && order.delivery_info?.type === 'delivery' && (
                                                                <Button
                                                                    onClick={() => {
                                                                        setSelectedOrder(order);
                                                                        setShowDeliveryModal(true);
                                                                    }}
                                                                    className="w-full h-12 rounded-xl bg-[#FF9900] text-white text-[10px] font-black uppercase tracking-widest shadow-xl flex items-center justify-center gap-2"
                                                                >
                                                                    <MapPin className="w-5 h-5" /> Mande Chofè
                                                                </Button>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ) : (
                                <div className="p-24 text-center">
                                    <ShoppingBag className="w-16 h-16 text-gray-100 mx-auto mb-6" />
                                    <p className="text-gray-400 text-[10px] font-black uppercase tracking-widest">Ou poko resevwa okenn kòmand nan magazen w lan.</p>
                                </div>
                            )}
                        </CardContent>
                    </Card>
                )}

                {activeTab === "list_requests" && (
                    <Card className="rounded-[50px] border-none shadow-2xl overflow-hidden bg-white">
                        <CardHeader className="p-10 border-b border-gray-50 bg-[#FF9900]/5 flex flex-row items-center justify-between">
                            <CardTitle className="text-2xl font-black text-gray-900 uppercase tracking-tighter italic flex items-center gap-3">
                                <ClipboardList className="w-6 h-6 text-[#FF9900]" /> Demann Lis (Quotes)
                            </CardTitle>
                        </CardHeader>
                        <CardContent className="p-0">
                            {listRequests.length > 0 ? (
                                <div className="overflow-x-auto">
                                    {/* Desktop Table */}
                                    <table className="w-full hidden md:table">
                                        <thead className="bg-gray-50/50 text-gray-300 text-left">
                                            <tr>
                                                <th className="px-10 py-6 text-[10px] font-black uppercase tracking-[0.2em]">Kliyan</th>
                                                <th className="px-8 py-6 text-[10px] font-black uppercase tracking-[0.2em]">Lis Atik</th>
                                                <th className="px-8 py-6 text-[10px] font-black uppercase tracking-[0.2em]">Estati</th>
                                                <th className="px-8 py-6 text-[10px] font-black uppercase tracking-[0.2em] text-center">Aksyon</th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-50">
                                            {listRequests.map((req) => (
                                                <tr key={req.id} className="hover:bg-gray-50/50 transition-all border-b border-gray-50">
                                                    <td className="px-10 py-6">
                                                        <div className="flex flex-col">
                                                            <span className="font-black text-gray-900 tracking-tight">{req.buyer_name}</span>
                                                            <span className="text-[10px] text-gray-400 font-bold">{req.buyer_phone}</span>
                                                        </div>
                                                    </td>
                                                    <td className="px-8 py-6 max-w-xs">
                                                        <p className="text-[11px] font-bold text-gray-600 line-clamp-2 italic">{req.items_text}</p>
                                                    </td>
                                                    <td className="px-8 py-6">
                                                        <span className={`px-4 py-1.5 rounded-xl text-[9px] font-black uppercase tracking-widest shadow-sm ${
                                                            req.status === 'paid' ? 'bg-green-500 text-white' :
                                                            req.status === 'quoted' ? 'bg-blue-500 text-white' :
                                                            req.status === 'confirmed' ? 'bg-purple-500 text-white' :
                                                            'bg-amber-100 text-amber-600'
                                                        }`}>
                                                            {req.status === 'pending' ? 'Nouvo' : 
                                                             req.status === 'quoted' ? 'Pri Voye' : 
                                                             req.status === 'confirmed' ? 'Kliyan Aksepte' :
                                                             req.status === 'paid' ? 'Peye' : req.status}
                                                        </span>
                                                    </td>
                                                    <td className="px-8 py-6 text-center">
                                                        {req.status === 'pending' && (
                                                            <Button
                                                                onClick={() => {
                                                                    setSelectedList(req);
                                                                    setQuoteItems(parseRequestedItems(req.items_text));
                                                                    setShowQuoteModal(true);
                                                                }}
                                                                className="bg-[#232F3E] text-[#FF9900] h-10 px-6 rounded-xl font-black text-[10px] uppercase shadow-lg"
                                                            >
                                                                Mete Pri
                                                            </Button>
                                                        )}
                                                        {(req.status === 'quoted' || req.status === 'confirmed' || req.status === 'paid') && (
                                                            <div className="flex flex-col items-center">
                                                                <span className="text-[10px] font-black text-gray-900">{req.total_htg?.toLocaleString()} HTG</span>
                                                            </div>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                    {/* Mobile Cards */}
                                    <div className="md:hidden flex flex-col divide-y divide-gray-100">
                                        {listRequests.map((req) => (
                                            <div key={req.id} className="p-6 space-y-4">
                                                <div className="flex justify-between items-start">
                                                    <div>
                                                        <h4 className="font-black text-gray-900 uppercase tracking-tighter text-sm italic">{req.buyer_name}</h4>
                                                        <p className="text-[10px] text-gray-400 font-bold">{req.buyer_phone}</p>
                                                    </div>
                                                    <span className={`px-3 py-1 rounded-lg text-[8px] font-black uppercase tracking-widest ${
                                                        req.status === 'paid' ? 'bg-green-500 text-white' :
                                                        req.status === 'quoted' ? 'bg-blue-500 text-white' :
                                                        'bg-amber-100 text-amber-600'
                                                    }`}>
                                                        {req.status === 'pending' ? 'Nouvo' : req.status}
                                                    </span>
                                                </div>
                                                <div className="bg-gray-50 p-4 rounded-2xl">
                                                    <p className="text-[10px] text-gray-500 font-bold italic line-clamp-3 leading-relaxed">"{req.items_text}"</p>
                                                </div>
                                                <div className="pt-2">
                                                    {req.status === 'pending' ? (
                                                        <Button
                                                            onClick={() => {
                                                                setSelectedList(req);
                                                                setQuoteItems(parseRequestedItems(req.items_text));
                                                                setShowQuoteModal(true);
                                                            }}
                                                            className="w-full h-12 bg-[#232F3E] text-[#FF9900] rounded-xl font-black text-[10px] uppercase shadow-xl"
                                                        >
                                                            Mete Pri Kounye a
                                                        </Button>
                                                    ) : (
                                                        <div className="flex justify-between items-center px-2">
                                                            <span className="text-[9px] font-black text-gray-400 uppercase tracking-widest">Total Quote</span>
                                                            <span className="text-sm font-black text-gray-900 italic">{req.total_htg?.toLocaleString()} HTG</span>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ) : (
                                <div className="p-24 text-center">
                                    <ClipboardList className="w-16 h-16 text-gray-100 mx-auto mb-6" />
                                    <p className="text-gray-400 text-[10px] font-black uppercase tracking-widest">Ou poko gen okenn demann lis.</p>
                                </div>
                            )}
                        </CardContent>
                    </Card>
                )}

                {activeTab === "wallet" && (
                     <div className="grid grid-cols-1 gap-8 sm:gap-12">
                         <Card className="rounded-[40px] border-none shadow-premium bg-white p-6 sm:p-12">
                            <div className="flex flex-col items-center sm:items-start lg:flex-row lg:items-center justify-between gap-8 py-4 sm:py-10">
                                <div className="text-center sm:text-left">
                                    <p className="text-gray-400 font-black uppercase tracking-[0.2em] text-[9px] sm:text-[10px] mb-2">Balans ou Genyen</p>
                                    <h2 className="text-4xl sm:text-6xl font-black text-gray-900 italic tracking-tighter shrink-0">
                                        {wallet.available_balance.toLocaleString()} <span className="text-sm sm:text-xl not-italic text-gray-400 uppercase tracking-widest font-bold">HTG</span>
                                    </h2>
                                </div>
                                <div className="flex flex-col gap-4 w-full lg:w-auto">
                                    <Button 
                                        onClick={() => setShowWithdrawModal(true)}
                                        disabled={wallet.available_balance < 500}
                                        className="h-16 sm:h-20 px-8 sm:px-12 bg-blue-600 hover:bg-black text-white rounded-[22px] sm:rounded-[25px] font-black text-base sm:text-xl uppercase tracking-widest shadow-2xl shadow-blue-200 transition-all flex gap-3 sm:gap-4 items-center justify-center"
                                    >
                                        <DollarSign className="w-6 h-6 sm:w-8 sm:h-8" /> Mande Retrè
                                    </Button>
                                    <p className="text-[10px] text-gray-400 font-black uppercase tracking-widest text-center mt-2">Retrè Minimòm se 500 HTG</p>
                                </div>
                            </div>

                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mt-8 sm:mt-12 pt-8 sm:pt-12 border-t border-gray-50">
                                <div className="bg-green-50 rounded-[25px] sm:rounded-[30px] p-6 sm:p-8">
                                    <div className="flex justify-between items-start mb-2">
                                        <p className="text-[9px] sm:text-[10px] font-black text-green-600 uppercase tracking-widest">Total Rantre (Depo)</p>
                                        <PlusCircle className="w-4 h-4 text-green-400" />
                                    </div>
                                    <p className="text-xl sm:text-3xl font-black text-gray-900 italic">{wallet.total_earnings.toLocaleString()} HTG</p>
                                </div>
                                <div className="bg-red-50 rounded-[25px] sm:rounded-[30px] p-6 sm:p-8">
                                    <div className="flex justify-between items-start mb-2">
                                        <p className="text-[9px] sm:text-[10px] font-black text-red-600 uppercase tracking-widest">Retrè Fè Deja (Sòti)</p>
                                        <Minus className="w-4 h-4 text-red-400" />
                                    </div>
                                    <p className="text-xl sm:text-3xl font-black text-gray-900 italic">{(wallet.total_earnings - wallet.available_balance).toLocaleString()} HTG</p>
                                </div>
                            </div>
                         </Card>

                         <Card className="rounded-[40px] sm:rounded-[50px] border-none shadow-2xl overflow-hidden bg-white">
                            <CardHeader className="p-6 sm:p-10 border-b border-gray-50 flex flex-row items-center justify-between">
                                <CardTitle className="text-xl sm:text-2xl font-black text-gray-900 uppercase tracking-tighter italic">Istwa Operasyon (Depo \u0026 Retrè)</CardTitle>
                            </CardHeader>
                            <CardContent className="p-0">
                                <div className="overflow-x-auto">
                                    {/* Unified Transaction List: Orders (Deposits) and Withdrawals */}
                                    {(() => {
                                        const transactions = [
                                            ...(orders || []).map(o => ({
                                                id: o.id,
                                                type: 'deposit',
                                                amount: o.seller_amount_htg !== undefined ? o.seller_amount_htg : (o.items ? o.items.reduce((sum, item) => sum + ((item.price || 0) * (item.quantity || 1)), 0) : ((o.price_htg || 0) - (o.commission_htg || 0))),
                                                status: 'completed',
                                                details: `Vant: ${o.product_title}`,
                                                date: o.created_at
                                            })),
                                            ...(wallet.withdrawals || []).map(w => ({
                                                id: w.id,
                                                type: 'withdrawal',
                                                amount: w.amount_htg,
                                                status: w.status,
                                                details: `Retrè: ${w.payment_method} (${w.payment_details})`,
                                                date: w.created_at
                                            }))
                                        ].sort((a, b) => new Date(b.date) - new Date(a.date));

                                        if (transactions.length === 0) {
                                            return (
                                                <div className="p-16 sm:p-24 text-center">
                                                    <p className="text-gray-400 text-[10px] font-black uppercase tracking-widest">Pa gen okenn tranzaksyon ankò.</p>
                                                </div>
                                            );
                                        }

                                        return (
                                            <>
                                                {/* Desktop Table */}
                                                <table className="w-full hidden md:table">
                                                    <thead className="bg-gray-50/50 text-gray-300 text-left">
                                                        <tr>
                                                            <th className="px-10 py-6 text-[10px] font-black uppercase tracking-[0.2em]">Kalite</th>
                                                            <th className="px-8 py-6 text-[10px] font-black uppercase tracking-[0.2em]">Detay</th>
                                                            <th className="px-8 py-6 text-[10px] font-black uppercase tracking-[0.2em]">Montan</th>
                                                            <th className="px-8 py-6 text-[10px] font-black uppercase tracking-[0.2em]">Estati</th>
                                                            <th className="px-8 py-6 text-[10px] font-black uppercase tracking-[0.2em]">Dat</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="divide-y divide-gray-50">
                                                        {transactions.map((t, idx) => (
                                                            <tr key={t.id || idx} className="hover:bg-gray-50/50 transition-all">
                                                                <td className="px-10 py-6">
                                                                    <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${t.type === 'deposit' ? 'bg-green-100 text-green-600' : 'bg-red-100 text-red-600'}`}>
                                                                        {t.type === 'deposit' ? <PlusCircle className="w-5 h-5" /> : <Minus className="w-5 h-5" />}
                                                                    </div>
                                                                </td>
                                                                <td className="px-8 py-6">
                                                                    <span className="text-[11px] font-black uppercase italic tracking-tighter text-gray-700">{t.details}</span>
                                                                </td>
                                                                <td className="px-8 py-6">
                                                                    <span className={`font-black text-lg ${t.type === 'deposit' ? 'text-green-600' : 'text-red-500'}`}>
                                                                        {t.type === 'deposit' ? '+' : '-'}{(t.amount || 0).toLocaleString()} <span className="text-[9px] text-gray-400">HTG</span>
                                                                    </span>
                                                                </td>
                                                                <td className="px-8 py-6">
                                                                    <span className={`px-4 py-1.5 rounded-xl text-[9px] font-black uppercase tracking-widest ${
                                                                        t.status === 'paid' || t.status === 'completed' ? 'bg-green-100 text-green-600' :
                                                                        t.status === 'pending' ? 'bg-amber-100 text-amber-600' :
                                                                        'bg-red-100 text-red-600'
                                                                    }`}>
                                                                        {t.status === 'completed' ? 'Siksè' : t.status === 'pending' ? 'An atant' : t.status}
                                                                    </span>
                                                                </td>
                                                                <td className="px-8 py-6">
                                                                    <span className="text-xs text-gray-400 font-bold">{new Date(t.date).toLocaleDateString()}</span>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>

                                                {/* Mobile Cards */}
                                                <div className="md:hidden flex flex-col divide-y divide-gray-50">
                                                    {transactions.map((t, idx) => (
                                                        <div key={t.id || idx} className="p-6 flex justify-between items-center bg-white hover:bg-gray-50 transition-colors">
                                                            <div className="flex gap-4 items-center">
                                                                <div className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${t.type === 'deposit' ? 'bg-green-100 text-green-600' : 'bg-red-100 text-red-600'}`}>
                                                                    {t.type === 'deposit' ? <PlusCircle className="w-5 h-5" /> : <Minus className="w-5 h-5" />}
                                                                </div>
                                                                <div>
                                                                    <p className={`text-base font-black ${t.type === 'deposit' ? 'text-green-600' : 'text-red-500'}`}>
                                                                        {t.type === 'deposit' ? '+' : '-'}{(t.amount || 0).toLocaleString()} <span className="text-[10px] text-gray-400">HTG</span>
                                                                    </p>
                                                                    <p className="text-[10px] font-black text-gray-400 uppercase mt-0.5 italic line-clamp-1">{t.details}</p>
                                                                    <p className="text-[8px] font-bold text-gray-300 mt-0.5">{new Date(t.date).toLocaleString()}</p>
                                                                </div>
                                                            </div>
                                                            <span className={`px-3 py-1 rounded-lg text-[8px] font-black uppercase tracking-widest ${
                                                                t.status === 'paid' || t.status === 'completed' ? 'bg-green-500 text-white' : 'bg-amber-500 text-white'
                                                            }`}>
                                                                {t.status === 'completed' ? 'OK' : '...'}
                                                            </span>
                                                        </div>
                                                    ))}
                                                </div>
                                            </>
                                        );
                                    })()}
                                </div>
                            </CardContent>
                         </Card>
                     </div>
                )}

                {/* ===================== LOCATION TAB ===================== */}
                {activeTab === "location" && (() => {
                    const saveStoreLocation = async (lat, lng, address) => {
                        const token = localStorage.getItem("seller_token");
                        setLocationLoading(true);
                        try {
                            const res = await axios.put(`${API}/sellers/profile/location`, { lat, lng, address }, {
                                headers: { Authorization: `Bearer ${token}` }
                            });
                            if (res.data.success) {
                                setStoreLocation({ lat, lng, address });
                                const updated = { ...seller, store_location: { lat, lng, address } };
                                setSeller(updated);
                                localStorage.setItem("seller_data", JSON.stringify(updated));
                                toast.success("ðŸ“ Lokasyon magazen ou sove!");
                            }
                        } catch (e) {
                            toast.error("Erè nan sove lokasyon an.");
                        } finally {
                            setLocationLoading(false);
                        }
                    };

                    const getCurrentLocation = () => {
                        if (!navigator.geolocation) {
                            return toast.error("GPS pa disponib sou aparèy sa a.");
                        }
                        setLocationLoading(true);
                        navigator.geolocation.getCurrentPosition(
                            async (pos) => {
                                const { latitude, longitude } = pos.coords;
                                // Reverse geocode with nominatim (free)
                                let address = `${latitude.toFixed(5)}, ${longitude.toFixed(5)}`;
                                try {
                                    const geoRes = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`);
                                    const geoData = await geoRes.json();
                                    address = geoData.display_name || address;
                                } catch {}
                                await saveStoreLocation(latitude, longitude, address);
                            },
                            (err) => {
                                setLocationLoading(false);
                                toast.error("Pa ka jwenn GPS ou: " + err.message);
                            },
                            { enableHighAccuracy: true, timeout: 10000 }
                        );
                    };

                    const currentLoc = storeLocation || seller?.store_location;
                    
                    return (
                        <div className="space-y-8 animate-in fade-in slide-in-from-bottom duration-500">
                            <Card className="rounded-[40px] border-none shadow-2xl bg-white overflow-hidden">
                                <CardHeader className="p-8 sm:p-12 border-b border-gray-50">
                                    <div className="flex items-start justify-between gap-6 flex-wrap">
                                        <div>
                                            <CardTitle className="text-2xl font-black text-gray-900 uppercase tracking-tighter italic flex items-center gap-3">
                                                <div className="w-10 h-10 rounded-2xl bg-[#FF9900]/10 flex items-center justify-center">
                                                    <MapPin className="w-5 h-5 text-[#FF9900]" />
                                                </div>
                                                Lokasyon Magazen ou
                                            </CardTitle>
                                            <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mt-2">
                                                Enpòtan â€” Chofè a bezwen kote magazen ou ye pou vini pran kòmand lan.
                                            </p>
                                        </div>
                                        {currentLoc && (
                                            <div className="flex items-center gap-2 px-4 py-2 bg-green-50 border border-green-100 rounded-2xl">
                                                <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
                                                <span className="text-[9px] font-black text-green-600 uppercase tracking-widest">Lokasyon Konfime</span>
                                            </div>
                                        )}
                                    </div>
                                </CardHeader>
                                <CardContent className="p-8 sm:p-12 space-y-8">
                                    {/* GPS Capture button */}
                                    <button
                                        onClick={getCurrentLocation}
                                        disabled={locationLoading}
                                        style={{
                                            width: '100%', height: '70px',
                                            background: locationLoading ? '#f1f5f9' : 'linear-gradient(135deg, #FF9900, #e68a00)',
                                            border: 'none', borderRadius: '20px',
                                            color: locationLoading ? '#94a3b8' : '#000',
                                            fontSize: '13px', fontWeight: '900',
                                            textTransform: 'uppercase', letterSpacing: '0.1em',
                                            cursor: locationLoading ? 'not-allowed' : 'pointer',
                                            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px',
                                            boxShadow: locationLoading ? 'none' : '0 10px 40px rgba(255,153,0,0.3)',
                                            transition: 'all 0.2s'
                                        }}
                                    >
                                        {locationLoading ? (
                                            <>
                                                <Loader2 style={{ width: '20px', height: '20px', animation: 'spin 1s linear infinite' }} />
                                                Ap chèche lokasyon ou...
                                            </>
                                        ) : (
                                            <>
                                                <MapPin style={{ width: '22px', height: '22px' }} />
                                                ðŸ“ Kaptire Lokasyon Magazen Mwen Kounye A
                                            </>
                                        )}
                                    </button>

                                    {/* Current location display */}
                                    {currentLoc && (
                                        <div style={{
                                            background: 'linear-gradient(135deg, #0F172A 0%, #1E293B 100%)',
                                            borderRadius: '24px', padding: '24px',
                                            border: '1px solid rgba(255,255,255,0.06)'
                                        }}>
                                            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px', marginBottom: '20px' }}>
                                                <div style={{
                                                    width: '44px', height: '44px', borderRadius: '14px',
                                                    background: 'rgba(255,153,0,0.15)',
                                                    display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0
                                                }}>
                                                    <MapPin style={{ width: '20px', height: '20px', color: '#FF9900' }} />
                                                </div>
                                                <div style={{ flex: 1 }}>
                                                    <p style={{ fontSize: '9px', fontWeight: '800', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.15em', marginBottom: '6px' }}>
                                                        Lokasyon Magazen Konfime
                                                    </p>
                                                    <p style={{ fontSize: '12px', fontWeight: '700', color: '#fff', lineHeight: 1.5 }}>
                                                        {currentLoc.address}
                                                    </p>
                                                    <p style={{ fontSize: '10px', fontWeight: '600', color: '#FF9900', marginTop: '6px', fontFamily: 'monospace' }}>
                                                        {currentLoc.lat?.toFixed(6)}, {currentLoc.lng?.toFixed(6)}
                                                    </p>
                                                </div>
                                            </div>
                                            <div style={{ display: 'flex', gap: '10px' }}>
                                                <a
                                                    href={`https://www.google.com/maps?q=${currentLoc.lat},${currentLoc.lng}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{
                                                        flex: 1, height: '44px',
                                                        background: 'rgba(255,255,255,0.08)',
                                                        border: '1px solid rgba(255,255,255,0.1)',
                                                        borderRadius: '12px', color: '#fff',
                                                        fontSize: '9px', fontWeight: '900',
                                                        textTransform: 'uppercase', letterSpacing: '0.1em',
                                                        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px',
                                                        textDecoration: 'none', cursor: 'pointer'
                                                    }}
                                                >
                                                    <ExternalLink style={{ width: '14px', height: '14px' }} />
                                                    Wè sou Google Maps
                                                </a>
                                                <button
                                                    onClick={getCurrentLocation}
                                                    style={{
                                                        flex: 1, height: '44px',
                                                        background: 'rgba(255,153,0,0.15)',
                                                        border: '1px solid rgba(255,153,0,0.3)',
                                                        borderRadius: '12px', color: '#FF9900',
                                                        fontSize: '9px', fontWeight: '900',
                                                        textTransform: 'uppercase', letterSpacing: '0.1em',
                                                        cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px'
                                                    }}
                                                >
                                                    <MapPin style={{ width: '14px', height: '14px' }} />
                                                    Mete Ajou GPS
                                                </button>
                                            </div>
                                        </div>
                                    )}

                                    {/* Map embed preview */}
                                    {currentLoc && (
                                        <div style={{ borderRadius: '20px', overflow: 'hidden', height: '300px', border: '1px solid #e2e8f0' }}>
                                            <iframe
                                                title="Store Location"
                                                width="100%" height="100%"
                                                style={{ border: 'none' }}
                                                src={`https://www.openstreetmap.org/export/embed.html?bbox=${currentLoc.lng - 0.002},${currentLoc.lat - 0.002},${currentLoc.lng + 0.002},${currentLoc.lat + 0.002}&layer=mapnik&marker=${currentLoc.lat},${currentLoc.lng}`}
                                            />
                                        </div>
                                    )}

                                    {/* Instruction tip */}
                                    <div style={{
                                        display: 'flex', gap: '12px', padding: '16px 20px',
                                        background: '#F8FAFC', borderRadius: '16px',
                                        border: '1px solid #e2e8f0'
                                    }}>
                                        <div style={{ fontSize: '20px', flexShrink: 0 }}>ðŸ’¡</div>
                                        <div>
                                            <p style={{ fontSize: '10px', fontWeight: '800', color: '#374151', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: '4px' }}>
                                                Kijan sa travay?
                                            </p>
                                            <p style={{ fontSize: '11px', color: '#64748b', lineHeight: 1.6 }}>
                                                Klike bouton <strong>"Kaptire Lokasyon"</strong> la lè ou <strong>nan magazen ou</strong>. GPS ou an ap mete yon <strong>pin egzak</strong> sou kote ou ye a. Chofè yo ap resevwa lyen dirèk Google Maps pou vini jwenn ou. Pa bliye mete ajou si ou chanje kote magazen an.
                                            </p>
                                        </div>
                                    </div>
                                </CardContent>
                            </Card>
                        </div>
                    );
                })()}

                {activeTab === "reports" && (
                    <div className="space-y-8 animate-in fade-in slide-in-from-bottom duration-500">
                        {/* Reports Header & Filter */}
                        <Card className="rounded-[40px] border-none shadow-premium bg-white p-6 sm:p-10">
                            <div className="flex flex-col md:flex-row items-center justify-between gap-8">
                                <div>
                                    <h2 className="text-2xl font-black text-gray-900 uppercase tracking-tighter italic flex items-center gap-3">
                                        <BarChart3 className="w-6 h-6 text-[#FF9900]" /> Rapò Biznis ou
                                    </h2>
                                    <p className="text-[10px] text-gray-400 font-bold uppercase tracking-widest mt-1">Kontwole pèfòmans ou chak jou, mwa, ak ane.</p>
                                </div>
                                <div className="flex flex-wrap gap-2 justify-center">
                                    {['day', 'week', 'month', 'year'].map(p => (
                                        <button 
                                            key={p}
                                            onClick={() => {
                                                setReportPeriod(p);
                                                // Reset custom range when choosing preset
                                                setReportDateRange({ start: "", end: "" });
                                            }}
                                            className={`px-6 py-3 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all ${reportPeriod === p && !reportDateRange.start ? 'bg-[#FF9900] text-white shadow-lg shadow-orange-100' : 'bg-gray-50 text-gray-400 hover:bg-gray-100 hover:text-gray-600'}`}
                                        >
                                            Chak {p === 'day' ? 'Jou' : p === 'week' ? 'Semèn' : p === 'month' ? 'Mwa' : 'Ane'}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            <div className="mt-10 pt-10 border-t border-gray-50 flex flex-col md:flex-row items-end gap-6">
                                <div className="flex-1 w-full space-y-2">
                                    <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest ml-1">Filtre pa Dat (Opsyonèl)</label>
                                    <div className="grid grid-cols-2 gap-4">
                                        <div className="relative">
                                            <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-[#FF9900]" />
                                            <Input 
                                                type="date"
                                                value={reportDateRange.start}
                                                onChange={(e) => setReportDateRange(prev => ({ ...prev, start: e.target.value }))}
                                                className="h-14 pl-12 rounded-2xl bg-gray-50 border-none font-bold text-xs"
                                            />
                                        </div>
                                        <div className="relative">
                                            <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-[#FF9900]" />
                                            <Input 
                                                type="date"
                                                value={reportDateRange.end}
                                                onChange={(e) => setReportDateRange(prev => ({ ...prev, end: e.target.value }))}
                                                className="h-14 pl-12 rounded-2xl bg-gray-50 border-none font-bold text-xs"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <Button 
                                    onClick={() => setReportDateRange({ start: "", end: "" })}
                                    variant="outline"
                                    className="h-14 px-8 rounded-2xl border-2 border-gray-100 text-[10px] font-black uppercase tracking-widest hover:bg-red-50 hover:text-red-500 hover:border-red-100 shrink-0"
                                >
                                    Efase Filtre
                                </Button>
                            </div>
                        </Card>

                        {/* Metrics Grid */}
                        {(() => {
                            // Logic to calculate report data
                            const now = new Date();
                            const filterOrders = (orders || []).filter(o => {
                                if (o.payment_status !== 'completed') return false;
                                
                                const orderDate = new Date(o.created_at);
                                
                                // Custom range filter priority
                                if (reportDateRange.start && reportDateRange.end) {
                                    const start = new Date(reportDateRange.start);
                                    const end = new Date(reportDateRange.end);
                                    end.setHours(23, 59, 59);
                                    return orderDate >= start && orderDate <= end;
                                }
                                
                                // Preset filter
                                if (reportPeriod === 'day') {
                                    return orderDate.toDateString() === now.toDateString();
                                } else if (reportPeriod === 'week') {
                                    const weekAgo = new Date();
                                    weekAgo.setDate(now.getDate() - 7);
                                    return orderDate >= weekAgo;
                                } else if (reportPeriod === 'month') {
                                    return orderDate.getMonth() === now.getMonth() && orderDate.getFullYear() === now.getFullYear();
                                } else if (reportPeriod === 'year') {
                                    return orderDate.getFullYear() === now.getFullYear();
                                }
                                return true;
                            });

                            const totalSales = filterOrders.reduce((sum, o) => sum + (o.seller_amount_htg || 0), 0);
                            const avgOrder = filterOrders.length > 0 ? totalSales / filterOrders.length : 0;
                            
                            // Simple projection for "Coming Soon" chart feel
                            const labels = reportPeriod === 'year' ? ['JN', 'FV', 'MA', 'AV', 'ME', 'JN', 'JL', 'AG', 'ST', 'OK', 'NV', 'DS'] : ['L', 'M', 'M', 'J', 'V', 'S', 'D'];
                            const maxVal = Math.max(...labels.map(() => Math.random() * 100), 50);

                            return (
                                <div className="space-y-8">
                                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                                        <Card className="rounded-[40px] border-none shadow-premium bg-white p-10 overflow-hidden relative group hover:scale-[1.02] transition-all">
                                            <div className="absolute top-0 right-0 p-4 opacity-[0.03] translate-x-4 -translate-y-4">
                                                <DollarSign className="w-24 h-24 text-[#FF9900]" />
                                            </div>
                                            <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2">Total Vant</p>
                                            <h3 className="text-4xl font-black text-gray-900 italic tracking-tighter shrink-0">
                                                {totalSales.toLocaleString()} <span className="text-xs not-italic text-gray-400">HTG</span>
                                            </h3>
                                            <div className="mt-4 flex items-center gap-2">
                                                <div className="px-2 py-1 bg-green-100 rounded-lg text-green-600 text-[8px] font-black">+12.5%</div>
                                                <span className="text-[8px] text-gray-300 font-bold uppercase tracking-widest">depi dènye fwa</span>
                                            </div>
                                        </Card>
                                        <Card className="rounded-[40px] border-none shadow-premium bg-white p-10 overflow-hidden relative group hover:scale-[1.02] transition-all">
                                            <div className="absolute top-0 right-0 p-4 opacity-[0.03] translate-x-4 -translate-y-4">
                                                <Package className="w-24 h-24 text-blue-500" />
                                            </div>
                                            <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2">Kòmand Reyisi</p>
                                            <h3 className="text-4xl font-black text-gray-900 italic tracking-tighter shrink-0">
                                                {filterOrders.length} <span className="text-xs not-italic text-gray-400">KÒMAND</span>
                                            </h3>
                                            <div className="mt-4 flex items-center gap-2">
                                                <div className="px-2 py-1 bg-blue-100 rounded-lg text-blue-600 text-[8px] font-black">VOLIM</div>
                                                <span className="text-[8px] text-gray-300 font-bold uppercase tracking-widest">aktivite mache a</span>
                                            </div>
                                        </Card>
                                        <Card className="rounded-[40px] border-none shadow-premium bg-white p-10 overflow-hidden relative group hover:scale-[1.02] transition-all">
                                            <div className="absolute top-0 right-0 p-4 opacity-[0.03] translate-x-4 -translate-y-4">
                                                <Smartphone className="w-24 h-24 text-green-500" />
                                            </div>
                                            <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2">Mwayèn Vant</p>
                                            <h3 className="text-4xl font-black text-gray-900 italic tracking-tighter shrink-0">
                                                {Math.round(avgOrder).toLocaleString()} <span className="text-xs not-italic text-gray-400">HTG</span>
                                            </h3>
                                            <div className="mt-4 flex items-center gap-2">
                                                <div className="px-2 py-1 bg-amber-100 rounded-lg text-amber-600 text-[8px] font-black">PWOFI</div>
                                                <span className="text-[8px] text-gray-300 font-bold uppercase tracking-widest">pa kòmand</span>
                                            </div>
                                        </Card>
                                    </div>

                                    {/* Visual Performance Chart (Custom CSS) */}
                                    <Card className="rounded-[50px] border-none shadow-2xl overflow-hidden bg-[#232F3E] p-12 text-white">
                                        <div className="flex items-center justify-between mb-12">
                                            <div>
                                                <h3 className="text-xl font-black italic tracking-tighter uppercase leading-none mb-2">Pèfòmans Grafik</h3>
                                                <p className="text-[9px] text-gray-400 font-black uppercase tracking-[0.2em]">Vizyalizasyon kwasans biznis ou an (HTG)</p>
                                            </div>
                                            <div className="flex gap-4">
                                                <div className="flex items-center gap-2">
                                                    <div className="w-3 h-3 rounded-full bg-[#FF9900]" />
                                                    <span className="text-[8px] font-black uppercase text-gray-400">Vant Rezilta</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="h-[250px] flex items-end justify-between gap-2 sm:gap-6 px-4">
                                            {labels.map((l, i) => {
                                                const h = Math.floor(Math.random() * 80) + 15;
                                                return (
                                                    <div key={i} className="flex-1 flex flex-col items-center gap-4 group">
                                                        <div className="relative w-full flex justify-center">
                                                            <div 
                                                                style={{ height: `${h}%` }}
                                                                className="w-full sm:w-8 bg-[#FF9900]/20 group-hover:bg-[#FF9900] rounded-t-xl transition-all duration-500 relative cursor-pointer"
                                                            >
                                                                <div className="absolute -top-10 left-1/2 -translate-x-1/2 bg-white text-black px-2 py-1 rounded text-[8px] font-black opacity-0 group-hover:opacity-100 transition-opacity">
                                                                    {Math.round(h * (totalSales / 100)).toLocaleString()}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <span className="text-[9px] font-black text-gray-500 uppercase tracking-widest">{l}</span>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </Card>

                                    {/* Top Selling Products List */}
                                    <Card className="rounded-[40px] border-none shadow- premium bg-white overflow-hidden">
                                        <CardHeader className="p-8 border-b border-gray-50">
                                            <CardTitle className="text-xl font-black text-gray-900 uppercase tracking-tighter italic">Pwodwi ki plis vann</CardTitle>
                                        </CardHeader>
                                        <CardContent className="p-0">
                                            <div className="divide-y divide-gray-50">
                                                {filterOrders.length === 0 ? (
                                                    <div className="p-12 text-center text-gray-400 text-[10px] font-black uppercase tracking-widest">Pa gen aktivite nan tan sa a.</div>
                                                ) : (
                                                    Object.values(filterOrders.reduce((acc, o) => {
                                                        if (!acc[o.product_id]) acc[o.product_id] = { title: o.product_title, qty: 0, total: 0 };
                                                        acc[o.product_id].qty += o.quantity;
                                                        acc[o.product_id].total += o.seller_amount_htg;
                                                        return acc;
                                                    }, {})).sort((a,b) => b.total - a.total).slice(0, 5).map((p, idx) => (
                                                        <div key={idx} className="p-8 flex items-center justify-between hover:bg-gray-50 transition-colors">
                                                            <div className="flex items-center gap-6">
                                                                <div className="w-12 h-12 rounded-2xl bg-gray-100 flex items-center justify-center text-gray-400 font-black text-lg shadow-inner">
                                                                    {idx + 1}
                                                                </div>
                                                                <div>
                                                                    <h4 className="font-black text-gray-900 uppercase italic tracking-tighter text-sm">{p.title}</h4>
                                                                    <p className="text-[10px] text-gray-400 font-bold uppercase tracking-widest">{p.qty} Atik Vann</p>
                                                                </div>
                                                            </div>
                                                            <div className="text-right">
                                                                <p className="text-lg font-black text-[#FF9900] italic">{p.total.toLocaleString()} HTG</p>
                                                            </div>
                                                        </div>
                                                    ))
                                                )}
                                            </div>
                                        </CardContent>
                                    </Card>
                                </div>
                            );
                        })()}
                    </div>
                )}
                    </div>
                </div>

            {/* ADD PRODUCT MODAL */}
            <Dialog open={showAddModal} onOpenChange={setShowAddModal}>
                <DialogContent className="sm:max-w-[600px] p-0 overflow-hidden rounded-[50px] border-none shadow-2xl">
                    <DialogHeader className="p-12 pb-8 bg-[#232F3E] text-white">
                        <div className="w-14 h-14 bg-[#FF9900] rounded-2xl flex items-center justify-center mb-6 shadow-xl shadow-[#FF9900]/20">
                            <PlusCircle className="w-8 h-8 text-white" />
                        </div>
                        <DialogTitle className="text-3xl font-black tracking-tighter uppercase italic leading-none">Nouvo <span className="text-[#FF9900]">Atik</span></DialogTitle>
                        <DialogDescription className="text-gray-400 font-bold uppercase tracking-widest text-[9px] mt-2">Mete nouvo atik la nan magazen w lan kounye a.</DialogDescription>
                    </DialogHeader>

                    <form onSubmit={handleAddSubmit} className="p-12 space-y-8 bg-white overflow-y-auto max-h-[70vh]">
                        <div className="space-y-8 py-4 px-2">
                            {/* Tit Pwodwi */}
                            <div className="space-y-4">
                                <Label className="text-xs font-black uppercase tracking-wider text-gray-900 flex items-center gap-3">
                                    <div className="w-8 h-8 rounded-xl bg-[#FF9900]/10 flex items-center justify-center">
                                        <Tag className="w-4 h-4 text-[#FF9900]" />
                                    </div>
                                    Tit Pwodwi
                                </Label>
                                <Input
                                    placeholder="Egz: iPhone 15 Pro Max"
                                    className="h-16 rounded-[20px] bg-gray-50/50 border border-gray-100 hover:border-[#FF9900]/30 focus:border-[#FF9900] transition-all px-8 font-black text-gray-900 shadow-sm text-base"
                                    value={formData.title}
                                    onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                                    required
                                />
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                                {/* Kategori */}
                                <div className="space-y-4">
                                    <Label className="text-xs font-black uppercase tracking-wider text-gray-900 flex items-center gap-3">
                                        <div className="w-8 h-8 rounded-xl bg-[#FF9900]/10 flex items-center justify-center">
                                            <Briefcase className="w-4 h-4 text-[#FF9900]" />
                                        </div>
                                        Kategori
                                    </Label>
                                    <div className="relative group">
                                        <select
                                            className="w-full h-16 rounded-[20px] bg-gray-50/50 border border-gray-100 px-8 font-black text-sm outline-none cursor-pointer hover:border-[#FF9900]/30 transition-all appearance-none"
                                            value={formData.category}
                                            onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                                        >
                                            <option value="phones">Telefòn & Tablet</option>
                                            <option value="electronics">Elektwonik</option>
                                            <option value="vehicles">Veyikil</option>
                                            <option value="fashion">Mòd & Rad</option>
                                            <option value="home">Kay & Jaden</option>
                                            <option value="services">Sèvis</option>
                                        </select>
                                        <ChevronRight className="absolute right-8 top-1/2 -translate-y-1/2 rotate-90 w-4 h-4 text-gray-400 pointer-events-none group-hover:text-[#FF9900] transition-colors" />
                                    </div>
                                </div>
                                
                                {/* Tip Pwodwi */}
                                <div className="space-y-4">
                                <Label className="text-xs font-black uppercase tracking-wider text-gray-900 flex items-center gap-3">
                                    <div className="w-8 h-8 rounded-xl bg-[#FF9900]/10 flex items-center justify-center">
                                        <Package className="w-4 h-4 text-[#FF9900]" />
                                    </div>
                                    Tip Pwodwi
                                </Label>
                                    <div className="flex bg-gray-100/50 p-2 rounded-[20px] h-16 border border-gray-100">
                                        <button 
                                            type="button" 
                                            onClick={() => setFormData({ ...formData, type: 'physical' })} 
                                            className={`flex-1 rounded-xl text-[10px] font-black uppercase tracking-[0.1em] transition-all duration-300 ${formData.type === 'physical' ? 'bg-[#232F3E] text-white shadow-xl' : 'text-gray-400 hover:text-gray-600'}`}
                                        >
                                            Fizik
                                        </button>
                                        <button 
                                            type="button" 
                                            onClick={() => setFormData({ ...formData, type: 'digital' })} 
                                            className={`flex-1 rounded-xl text-[10px] font-black uppercase tracking-[0.1em] transition-all duration-300 ${formData.type === 'digital' ? 'bg-[#232F3E] text-white shadow-xl' : 'text-gray-400 hover:text-gray-600'}`}
                                        >
                                            Dijital
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                                {/* Pri */}
                                <div className="space-y-4">
                                    <Label className="text-xs font-black uppercase tracking-wider text-gray-900 flex items-center gap-3">
                                        <div className="w-8 h-8 rounded-xl bg-[#FF9900]/10 flex items-center justify-center">
                                            <DollarSign className="w-4 h-4 text-[#FF9900]" />
                                        </div>
                                        Pri (HTG)
                                    </Label>
                                    <div className="relative">
                                        <Input
                                            type="number"
                                            placeholder="50,000"
                                            className="h-16 rounded-[20px] bg-gray-50/50 border border-gray-100 px-8 font-black text-gray-900 text-2xl shadow-sm focus:border-[#FF9900]"
                                            value={formData.price_htg}
                                            onChange={(e) => setFormData({ ...formData, price_htg: e.target.value })}
                                            required
                                        />
                                        <span className="absolute right-8 top-1/2 -translate-y-1/2 text-[10px] font-black text-gray-400 tracking-widest uppercase">HTG</span>
                                    </div>
                                </div>

                                {/* Kondisyon */}
                                <div className="space-y-4">
                                <Label className="text-xs font-black uppercase tracking-wider text-gray-900 flex items-center gap-3">
                                    <div className="w-8 h-8 rounded-xl bg-[#FF9900]/10 flex items-center justify-center">
                                        <Eye className="w-4 h-4 text-[#FF9900]" />
                                    </div>
                                    Kondisyon
                                </Label>
                                    <div className="relative group">
                                        <select
                                            className="w-full h-16 rounded-[20px] bg-gray-50/50 border border-gray-100 px-8 font-black text-sm outline-none cursor-pointer appearance-none hover:border-[#FF9900]/30 transition-all"
                                            value={formData.condition}
                                            onChange={(e) => setFormData({ ...formData, condition: e.target.value })}
                                        >
                                            <option value="new">Nèf (New)</option>
                                            <option value="used_good">Itilize (Bon Eta)</option>
                                            <option value="used_fair">Itilize (Eta Mwayen)</option>
                                        </select>
                                        <ChevronRight className="absolute right-8 top-1/2 -translate-y-1/2 rotate-90 w-4 h-4 text-gray-400 pointer-events-none group-hover:text-[#FF9900] transition-colors" />
                                    </div>
                                </div>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                                {/* Vil / Zòn */}
                                <div className="space-y-4">
                                <Label className="text-xs font-black uppercase tracking-wider text-gray-900 flex items-center gap-3">
                                    <div className="w-8 h-8 rounded-xl bg-[#FF9900]/10 flex items-center justify-center">
                                        <MapPin className="w-4 h-4 text-[#FF9900]" />
                                    </div>
                                    Vil / Zòn (Livrezon)
                                </Label>
                                    <Input
                                        placeholder="Egz: Delmas, Pòtoprens..."
                                        className="h-16 rounded-[20px] bg-gray-50/50 border border-gray-100 px-8 font-black text-gray-900 shadow-sm focus:border-[#FF9900]"
                                        value={formData.location}
                                        onChange={(e) => setFormData({ ...formData, location: e.target.value })}
                                        required
                                    />
                                </div>

                                {/* KOTE POU L PARÈT (DISPLAY ON) */}
                                <div className="space-y-4">
                                    <Label className="text-xs font-black uppercase tracking-wider text-gray-900 flex items-center gap-3">
                                        <div className="w-8 h-8 rounded-xl bg-indigo-500/10 flex items-center justify-center">
                                            <LayoutDashboard className="w-4 h-4 text-indigo-500" />
                                        </div>
                                        Kote pou l parèt (Service)
                                    </Label>
                                    <div className="flex bg-gray-100/50 p-2 rounded-[20px] h-16 border border-gray-100">
                                        {[
                                            { id: 'marketplace', label: 'Market' },
                                            { id: 'pos', label: 'POS Online' },
                                            { id: 'both', label: 'Tou de' }
                                        ].map((opt) => (
                                            <button 
                                                key={opt.id}
                                                type="button" 
                                                onClick={() => setFormData({ ...formData, display_on: opt.id })} 
                                                className={`flex-1 rounded-xl text-[9px] font-black uppercase tracking-[0.1em] transition-all duration-300 ${formData.display_on === opt.id ? 'bg-indigo-600 text-white shadow-xl' : 'text-gray-400 hover:text-gray-600'}`}
                                            >
                                                {opt.label}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            {/* === VEYIKIL BEZWEN === */}
                            <div className="space-y-4">
                                <Label className="text-xs font-black uppercase tracking-wider text-gray-900 flex items-center gap-3">
                                    <div className="w-8 h-8 rounded-xl bg-orange-500/10 flex items-center justify-center">
                                        <span style={{fontSize:'16px'}}>ðŸš—</span>
                                    </div>
                                    Veyikil Bezwen pou Livrezon
                                </Label>
                                <div className="grid grid-cols-3 gap-3">
                                    {[
                                        { id: 'moto', emoji: 'ðŸï¸', label: 'Moto', sub: 'Lejè' },
                                        { id: 'machine', emoji: 'ðŸš—', label: 'Machin', sub: 'Mwayen' },
                                        { id: 'kamyon', emoji: 'ðŸš›', label: 'Kamyon', sub: 'Lou / Gwo' },
                                    ].map((v) => (
                                        <button key={v.id} type="button"
                                            onClick={() => setFormData({ ...formData, vehicle_required: v.id })}
                                            className={`flex flex-col items-center justify-center gap-1 p-4 rounded-2xl border-2 font-black transition-all ${
                                                formData.vehicle_required === v.id
                                                    ? 'border-[#FF9900] bg-[#FF9900]/10 text-gray-900'
                                                    : 'border-gray-100 bg-gray-50 text-gray-400 hover:border-gray-200'
                                            }`}
                                        >
                                            <span style={{fontSize:'24px'}}>{v.emoji}</span>
                                            <span className="text-[10px] uppercase tracking-widest">{v.label}</span>
                                            <span className="text-[8px] text-gray-400 uppercase">{v.sub}</span>
                                        </button>
                                    ))}
                                </div>
                                {formData.vehicle_required === 'kamyon' && (
                                    <div className="flex items-center gap-2 px-4 py-3 bg-amber-50 rounded-xl border border-amber-100">
                                        <span style={{fontSize:'14px'}}>âš ï¸</span>
                                        <p className="text-[9px] font-black text-amber-700 uppercase tracking-widest">Sèlman chofè kamyon ki ap wè kòmand sa a</p>
                                    </div>
                                )}
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                                {/* Imaj Upload */}
                                <div className="space-y-4">
                                    <Label className="text-[10px] font-black uppercase tracking-[0.2em] text-gray-700 flex items-center gap-3">
                                        <div className="w-6 h-6 rounded-lg bg-[#FF9900]/10 flex items-center justify-center">
                                            <Camera className="w-3.5 h-3.5 text-[#FF9900]" />
                                        </div>
                                        Foto Pwodwi
                                    </Label>
                                    <div className="flex flex-wrap gap-3">
                                        {(formData.images || []).filter(img => img).map((imgUrl, idx) => (
                                            <div key={idx} className="relative w-[100px] h-[100px] rounded-xl bg-gray-100 overflow-hidden border border-gray-200 shadow-sm">
                                                <img src={imgUrl} alt="Preview" className="w-full h-full object-cover" />
                                                <button type="button" onClick={() => handleRemoveImage(idx, false)} className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1 hover:bg-red-600 transition-colors z-[70]"><X className="w-3 h-3" /></button>
                                            </div>
                                        ))}
                                        {(formData.images || []).filter(img => img).length < 3 && (
                                            <div className="relative w-[100px] h-[100px] rounded-xl border-2 border-dashed border-gray-300 flex flex-col items-center justify-center bg-gray-50 hover:border-[#FF9900] hover:bg-[#FF9900]/5 transition-colors group">
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    className="absolute inset-0 opacity-0 z-[60] cursor-pointer w-full h-full"
                                                    onChange={(e) => handleFileUpload(e, false)}
                                                />
                                                <Camera className="w-6 h-6 text-gray-400 group-hover:text-[#FF9900] mb-1" />
                                                <span className="text-[8px] font-black uppercase text-gray-400 group-hover:text-[#FF9900]">Ajoute</span>
                                            </div>
                                        )}
                                    </div>
                                                                          <div className="mt-4 pt-4 border-t border-gray-100">
                                          <p className="text-[9px] font-bold text-gray-400 mb-3 uppercase tracking-wider">Oswa chwazi yon imaj defo:</p>
                                          <div className="flex flex-wrap gap-2">
                                              {DEFAULT_PRODUCT_IMAGES.map((img, idx) => (
                                                  <button 
                                                      key={idx}
                                                      type="button"
                                                      onClick={() => {
                                                          const currentImages = (formData.images || []).filter(i => i);
                                                          if (currentImages.length < 3) {
                                                              setFormData({...formData, images: [...currentImages, img.url]});
                                                          }
                                                      }}
                                                      className="w-10 h-10 rounded-lg overflow-hidden border-2 border-transparent hover:border-[#FF9900] hover:scale-110 transition-all shadow-sm"
                                                      title={img.name}
                                                  >
                                                      <img src={img.url} alt={img.name} className="w-full h-full object-cover" />
                                                  </button>
                                              ))}
                                          </div>
                                      </div>
                                      <p className="text-[9px] text-gray-400 font-bold uppercase tracking-wider">Ou ka mete jiska 3 foto.</p>
                                </div>
                            </div>

                            {/* Deskripsyon */}
                            <div className="space-y-4">
                                <Label className="text-[10px] font-black uppercase tracking-[0.2em] text-gray-700 flex items-center gap-3">
                                    <div className="w-6 h-6 rounded-lg bg-[#FF9900]/10 flex items-center justify-center">
                                        <LayoutDashboard className="w-3.5 h-3.5 text-[#FF9900]" />
                                    </div>
                                    Deskripsyon
                                </Label>
                                <Textarea
                                    className="rounded-[30px] bg-gray-50/50 border border-gray-100 p-8 font-bold text-sm min-h-[160px] focus:border-[#FF9900] shadow-sm"
                                    placeholder="Bay tout detay sou pwodwi a, koulè, kondisyon, ak kote moun nan ka vin pran li oswa jan livrezon an ap fèt..."
                                    value={formData.description}
                                    onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                                />
                            </div>
                        </div>

                        <div className="pt-6 pb-2">
                            <Button 
                                type="submit" 
                                disabled={addLoading} 
                                className="w-full h-20 bg-[#FF9900] hover:bg-[#E88B00] text-white font-black text-xl rounded-[30px] shadow-2xl shadow-[#FF9900]/30 tracking-tight uppercase hover:scale-[1.01] active:scale-[0.99] transition-all flex items-center justify-center gap-4"
                            >
                                {addLoading ? (
                                    <>
                                        <Loader2 className="w-6 h-6 animate-spin" /> AP POUT POU OU...
                                    </>
                                ) : (
                                    <>
                                        PUBLIYE PWODWI A KOUNYE A <ChevronRight className="w-6 h-6" />
                                    </>
                                )}
                            </Button>
                        </div>
                    </form>
                </DialogContent>
            </Dialog>

            {/* EDIT PRODUCT MODAL */}
            <Dialog open={!!editingProduct} onOpenChange={(open) => { if (!open) setEditingProduct(null); }}>
                <DialogContent className="sm:max-w-[600px] p-0 overflow-hidden rounded-[50px] border-none shadow-2xl">
                    <DialogHeader className="p-12 pb-8 bg-blue-50 text-blue-900 border-b border-blue-100">
                        <div className="flex items-center justify-between">
                            <div className="w-14 h-14 bg-white rounded-2xl flex items-center justify-center mb-6 shadow-sm border border-blue-100 text-blue-600">
                                <Edit className="w-8 h-8" />
                            </div>
                        </div>
                        <DialogTitle className="text-3xl font-black tracking-tighter uppercase italic leading-none">Modifye <span className="text-blue-600">Atik</span></DialogTitle>
                        <DialogDescription className="text-blue-500 font-bold uppercase tracking-widest text-[9px] mt-2">Chanje detay pwodwi sa a ou te poste a.</DialogDescription>
                    </DialogHeader>

                    <form onSubmit={handleEditSubmit} className="p-12 space-y-8 bg-white overflow-y-auto max-h-[70vh]">
                        <div className="space-y-8 py-4 px-2">
                            {/* Estati Pwodwi & KOTE L PARÈT Switch */}
                            <div className="bg-blue-50/50 p-8 rounded-[30px] border border-blue-100 shadow-sm space-y-8">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-3">
                                        <div className="w-10 h-10 rounded-xl bg-blue-600/10 flex items-center justify-center">
                                            <Settings className="w-5 h-5 text-blue-600" />
                                        </div>
                                        <Label className="text-[11px] font-black uppercase tracking-[0.1em] text-gray-700">ESTATI PWODWI</Label>
                                    </div>
                                    <div className="flex bg-white p-1 rounded-xl shadow-sm border border-blue-100">
                                        <button 
                                            type="button" 
                                            onClick={() => setEditFormData({ ...editFormData, is_active: true })} 
                                            className={`px-6 py-2.5 rounded-lg text-[10px] font-black uppercase tracking-widest transition-all ${editFormData.is_active ? 'bg-green-500 text-white shadow-lg' : 'text-gray-400 hover:text-gray-600'}`}
                                        >
                                            AN LIY
                                        </button>
                                        <button 
                                            type="button" 
                                            onClick={() => setEditFormData({ ...editFormData, is_active: false })} 
                                            className={`px-6 py-2.5 rounded-lg text-[10px] font-black uppercase tracking-widest transition-all ${!editFormData.is_active ? 'bg-red-500 text-white shadow-lg' : 'text-gray-400 hover:text-gray-600'}`}
                                        >
                                            SISPANN
                                        </button>
                                    </div>
                                </div>

                                <div className="h-px bg-blue-100 w-full"></div>

                                {/* KOTE POU L PARÈT (DISPLAY ON) - TOP PRIORITY */}
                                <div className="space-y-4">
                                    <Label className="text-[10px] font-black uppercase tracking-[0.2em] text-[#232F3E] flex items-center gap-3">
                                        <LayoutDashboard className="w-5 h-5 text-blue-600" />
                                        KI KOTE POU PWODWI SA PARÈT?
                                    </Label>
                                    <div className="flex bg-white p-1.5 rounded-[22px] h-16 border border-blue-200 shadow-md">
                                        {[
                                            { id: 'marketplace', label: 'MARKET SÈLMAN' },
                                            { id: 'pos', label: 'POS ONLINE SÈLMAN' },
                                            { id: 'both', label: 'TOU DE (MARKET + POS)' }
                                        ].map((opt) => (
                                            <button 
                                                key={opt.id}
                                                type="button" 
                                                onClick={() => setEditFormData({ ...editFormData, display_on: opt.id })} 
                                                className={`flex-1 rounded-xl text-[9px] font-black uppercase tracking-widest transition-all duration-300 ${editFormData.display_on === opt.id ? 'bg-indigo-600 text-white shadow-xl scale-[1.03]' : 'text-gray-400 hover:text-gray-600'}`}
                                            >
                                                {opt.label}
                                            </button>
                                        ))}
                                    </div>
                                    <p className="text-[10px] text-blue-400 font-bold italic tracking-tight text-center">Chwazi "POS ONLINE" si ou vle atik sa disparèt nan Market la pou l rete sèlman nan magazen POS ou an.</p>
                                </div>
                            </div>

                            {/* Tit Pwodwi */}
                            <div className="space-y-4">
                                <Label className="text-[10px] font-black uppercase tracking-[0.2em] text-gray-700 flex items-center gap-3">
                                    <div className="w-6 h-6 rounded-lg bg-blue-50 flex items-center justify-center">
                                        <Tag className="w-3.5 h-3.5 text-blue-600" />
                                    </div>
                                    Tit Pwodwi
                                </Label>
                                <Input
                                    placeholder="Egz: iPhone 15 Pro Max"
                                    className="h-16 rounded-[20px] bg-gray-50/50 border border-gray-100 hover:border-blue-300 focus:border-blue-600 transition-all px-8 font-black text-gray-900 shadow-sm text-base"
                                    value={editFormData.title}
                                    onChange={(e) => setEditFormData({ ...editFormData, title: e.target.value })}
                                    required
                                />
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                                <div className="space-y-4">
                                    <Label className="text-[10px] font-black uppercase tracking-[0.2em] text-gray-700 flex items-center gap-3">
                                        <div className="w-6 h-6 rounded-lg bg-blue-50 flex items-center justify-center">
                                            <Briefcase className="w-3.5 h-3.5 text-blue-600" />
                                        </div>
                                        Kategori
                                    </Label>
                                    <div className="relative group">
                                        <select
                                            className="w-full h-16 rounded-[20px] bg-gray-50/50 border border-gray-100 px-8 font-black text-sm outline-none cursor-pointer hover:border-blue-300 transition-all appearance-none"
                                            value={editFormData.category}
                                            onChange={(e) => setEditFormData({ ...editFormData, category: e.target.value })}
                                        >
                                            <option value="phones">Telefòn & Tablet</option>
                                            <option value="electronics">Elektwonik</option>
                                            <option value="vehicles">Veyikil</option>
                                            <option value="fashion">Mòd & Rad</option>
                                            <option value="home">Kay & Jaden</option>
                                            <option value="services">Sèvis</option>
                                        </select>
                                        <ChevronRight className="absolute right-8 top-1/2 -translate-y-1/2 rotate-90 w-4 h-4 text-gray-400 group-hover:text-blue-600 transition-colors pointer-events-none" />
                                    </div>
                                </div>
                                <div className="space-y-4">
                                    <Label className="text-[10px] font-black uppercase tracking-[0.2em] text-gray-700 flex items-center gap-3">
                                        <div className="w-6 h-6 rounded-lg bg-blue-50 flex items-center justify-center">
                                            <Package className="w-3.5 h-3.5 text-blue-600" />
                                        </div>
                                        Tip Pwodwi
                                    </Label>
                                    <div className="flex bg-gray-100/50 p-2 rounded-[20px] h-16 border border-gray-100">
                                        <button 
                                            type="button" 
                                            onClick={() => setEditFormData({ ...editFormData, type: 'physical' })} 
                                            className={`flex-1 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all ${editFormData.type === 'physical' ? 'bg-blue-600 text-white shadow-xl' : 'text-gray-400 hover:text-gray-600'}`}
                                        >
                                            Fizik
                                        </button>
                                        <button 
                                            type="button" 
                                            onClick={() => setEditFormData({ ...editFormData, type: 'digital' })} 
                                            className={`flex-1 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all ${editFormData.type === 'digital' ? 'bg-blue-600 text-white shadow-xl' : 'text-gray-400 hover:text-gray-600'}`}
                                        >
                                            Dijital
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                                <div className="space-y-4">
                                    <Label className="text-[10px] font-black uppercase tracking-[0.2em] text-gray-700 flex items-center gap-3">
                                        <div className="w-6 h-6 rounded-lg bg-blue-50 flex items-center justify-center">
                                            <DollarSign className="w-3.5 h-3.5 text-blue-600" />
                                        </div>
                                        Pri (HTG)
                                    </Label>
                                    <div className="relative">
                                        <Input
                                            type="number"
                                            className="h-16 rounded-[20px] bg-gray-50/50 border border-gray-100 px-8 font-black text-gray-900 text-2xl shadow-sm focus:border-blue-600"
                                            value={editFormData.price_htg}
                                            onChange={(e) => setEditFormData({ ...editFormData, price_htg: e.target.value })}
                                            required
                                        />
                                        <span className="absolute right-8 top-1/2 -translate-y-1/2 text-[10px] font-black text-gray-400 uppercase tracking-widest">HTG</span>
                                    </div>
                                </div>
                                <div className="space-y-4">
                                    <Label className="text-[10px] font-black uppercase tracking-[0.2em] text-gray-700 flex items-center gap-3">
                                        <div className="w-6 h-6 rounded-lg bg-blue-50 flex items-center justify-center">
                                            <Eye className="w-3.5 h-3.5 text-blue-600" />
                                        </div>
                                        Kondisyon
                                    </Label>
                                    <div className="relative group">
                                        <select
                                            className="w-full h-16 rounded-[20px] bg-gray-50/50 border border-gray-100 px-8 font-black text-sm outline-none cursor-pointer appearance-none hover:border-blue-300 transition-all"
                                            value={editFormData.condition}
                                            onChange={(e) => setEditFormData({ ...editFormData, condition: e.target.value })}
                                        >
                                            <option value="new">Nèf (New)</option>
                                            <option value="used_good">Itilize (Bon Eta)</option>
                                            <option value="used_fair">Itilize (Eta Mwayen)</option>
                                        </select>
                                        <ChevronRight className="absolute right-8 top-1/2 -translate-y-1/2 rotate-90 w-4 h-4 text-gray-400 group-hover:text-blue-600 transition-colors pointer-events-none" />
                                    </div>
                                </div>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                                {/* Vil / Zòn */}
                                <div className="space-y-4">
                                    <Label className="text-[10px] font-black uppercase tracking-[0.2em] text-gray-700 flex items-center gap-3">
                                        <div className="w-6 h-6 rounded-lg bg-blue-50 flex items-center justify-center">
                                            <MapPin className="w-3.5 h-3.5 text-blue-600" />
                                        </div>
                                        Vil / Zòn
                                    </Label>
                                    <Input
                                        placeholder="Egz: Delmas, Pòtoprens..."
                                        className="h-16 rounded-[20px] bg-gray-50/50 border border-gray-100 px-8 font-black text-gray-900 shadow-sm focus:border-blue-600"
                                        value={editFormData.location}
                                        onChange={(e) => setEditFormData({ ...editFormData, location: e.target.value })}
                                        required
                                    />
                                </div>

                                {/* Imaj Upload */}
                                <div className="space-y-4">
                                    <Label className="text-[10px] font-black uppercase tracking-[0.2em] text-gray-700 flex items-center gap-3">
                                        <div className="w-6 h-6 rounded-lg bg-blue-50 flex items-center justify-center">
                                            <Camera className="w-3.5 h-3.5 text-blue-600" />
                                        </div>
                                        Foto Pwodwi
                                    </Label>
                                    <div className="flex flex-wrap gap-3">
                                        {(editFormData.images || []).filter(img => img).map((imgUrl, idx) => (
                                            <div key={idx} className="relative w-[100px] h-[100px] rounded-xl bg-gray-100 overflow-hidden border border-gray-200 shadow-sm">
                                                <img src={imgUrl} alt="Preview" className="w-full h-full object-cover" />
                                                <button type="button" onClick={() => handleRemoveImage(idx, true)} className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1 hover:bg-red-600 transition-colors z-[70]"><X className="w-3 h-3" /></button>
                                            </div>
                                        ))}
                                        {(editFormData.images || []).filter(img => img).length < 3 && (
                                            <div className="relative w-[100px] h-[100px] rounded-xl border-2 border-dashed border-blue-300 flex flex-col items-center justify-center bg-blue-50/50 hover:bg-blue-100 transition-colors group">
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    className="absolute inset-0 opacity-0 z-[60] cursor-pointer w-full h-full"
                                                    onChange={(e) => handleFileUpload(e, true)}
                                                />
                                                <Camera className="w-6 h-6 text-blue-400 group-hover:text-blue-600 mb-1" />
                                                <span className="text-[8px] font-black uppercase text-blue-400 group-hover:text-blue-600">Ajoute</span>
                                            </div>
                                        )}
                                    </div>
                                                                          <div className="mt-4 pt-4 border-t border-blue-100/50">
                                          <p className="text-[9px] font-bold text-gray-400 mb-3 uppercase tracking-wider">Oswa chwazi yon imaj defo:</p>
                                          <div className="flex flex-wrap gap-2">
                                              {DEFAULT_PRODUCT_IMAGES.map((img, idx) => (
                                                  <button 
                                                      key={idx}
                                                      type="button"
                                                      onClick={() => {
                                                          const currentImages = (editFormData.images || []).filter(i => i);
                                                          if (currentImages.length < 3) {
                                                              setEditFormData({...editFormData, images: [...currentImages, img.url]});
                                                          }
                                                      }}
                                                      className="w-10 h-10 rounded-lg overflow-hidden border-2 border-transparent hover:border-blue-500 hover:scale-110 transition-all shadow-sm"
                                                      title={img.name}
                                                  >
                                                      <img src={img.url} alt={img.name} className="w-full h-full object-cover" />
                                                  </button>
                                              ))}
                                          </div>
                                      </div>
                                      <p className="text-[9px] text-gray-400 font-bold uppercase tracking-wider">Ou ka mete jiska 3 foto.</p>
                                </div>
                            </div>
                            <div className="space-y-4">
                                <Label className="text-[10px] font-black uppercase tracking-[0.2em] text-gray-700 flex items-center gap-3">
                                    <div className="w-6 h-6 rounded-lg bg-blue-50 flex items-center justify-center">
                                        <Package className="w-3.5 h-3.5 text-blue-600" />
                                    </div>
                                    Stock (Kantite ki disponib)
                                </Label>
                                <Input
                                    type="number"
                                    className="h-16 rounded-[20px] bg-gray-50/50 border border-gray-100 px-8 font-black text-gray-900 shadow-sm focus:border-blue-600"
                                    value={editFormData.stock}
                                    onChange={(e) => setEditFormData({ ...editFormData, stock: e.target.value })}
                                    required
                                />
                            </div>

                            <div className="space-y-4">
                                <Label className="text-[10px] font-black uppercase tracking-[0.2em] text-gray-700 flex items-center gap-3">
                                    <div className="w-6 h-6 rounded-lg bg-blue-50 flex items-center justify-center">
                                        <ScanLine className="w-3.5 h-3.5 text-blue-600" />
                                    </div>
                                    Kòd Bar (Si l genyen)
                                </Label>
                                <Input
                                    type="text"
                                    className="h-16 rounded-[20px] bg-gray-50/50 border border-gray-100 px-8 font-black text-gray-900 shadow-sm focus:border-blue-600"
                                    placeholder="Eskane ak machin ou a la..."
                                    value={editFormData.barcode || ''}
                                    onChange={(e) => setEditFormData({ ...editFormData, barcode: e.target.value })}
                                />
                            </div>

                            <div className="space-y-4">
                                <Label className="text-[10px] font-black uppercase tracking-[0.2em] text-gray-700 flex items-center gap-3">
                                    <div className="w-6 h-6 rounded-lg bg-blue-50 flex items-center justify-center">
                                        <LayoutDashboard className="w-3.5 h-3.5 text-blue-600" />
                                    </div>
                                    Deskripsyon
                                </Label>
                                <Textarea
                                    className="rounded-[30px] bg-gray-50/50 border border-gray-100 p-8 font-bold text-sm min-h-[160px] focus:border-blue-600 shadow-sm"
                                    placeholder="Bay tout detay sou pwodwi a..."
                                    value={editFormData.description}
                                    onChange={(e) => setEditFormData({ ...editFormData, description: e.target.value })}
                                />
                            </div>
                        </div>

                        <div className="pt-6 pb-2">
                            <Button 
                                type="submit" 
                                disabled={editLoading} 
                                className="w-full h-20 bg-blue-600 hover:bg-blue-700 text-white font-black text-xl rounded-[30px] shadow-2xl shadow-blue-200 tracking-tight uppercase hover:scale-[1.01] active:scale-[0.99] transition-all flex items-center justify-center gap-4"
                            >
                                {editLoading ? (
                                    <>
                                        <Loader2 className="w-6 h-6 animate-spin" /> AP POUT POU OU...
                                    </>
                                ) : (
                                    <>
                                        KONFIME MODIFIKASYON YO <ChevronRight className="w-6 h-6" />
                                    </>
                                )}
                            </Button>
                        </div>
                    </form>
                </DialogContent>
            </Dialog>

            {/* WITHDRAW MODAL */}
            <Dialog open={showWithdrawModal} onOpenChange={setShowWithdrawModal}>
                <DialogContent className="sm:max-w-[500px] p-0 overflow-hidden rounded-[40px] border-none shadow-2xl">
                    <DialogHeader className="p-10 pb-6 bg-blue-600 text-white relative overflow-hidden">
                        <div className="absolute right-0 top-0 opacity-10">
                            <DollarSign className="w-40 h-40 -mt-10 -mr-10" />
                        </div>
                        <div className="w-14 h-14 bg-white/20 rounded-2xl flex items-center justify-center mb-6 backdrop-blur-sm">
                            <DollarSign className="w-8 h-8 text-white" />
                        </div>
                        <DialogTitle className="text-3xl font-black tracking-tighter uppercase italic leading-none z-10 relative">
                            Demann <span className="text-blue-200">Retrè</span>
                        </DialogTitle>
                        <DialogDescription className="text-blue-100 font-bold uppercase tracking-widest text-[9px] mt-2 z-10 relative">
                            Transfere kòb ou soti nan bous ou al sou MonCash ou.
                        </DialogDescription>
                    </DialogHeader>

                    <form onSubmit={handleWithdrawSubmit} className="p-10 space-y-6 bg-white">
                        <div className="bg-blue-50 p-6 rounded-3xl border border-blue-100 flex flex-col items-center justify-center text-center">
                            <span className="text-[10px] font-black uppercase tracking-widest text-blue-500 mb-1">Balans Aktiyèl Ou:</span>
                            <span className="text-4xl font-black text-blue-900 tracking-tighter">{wallet.available_balance.toLocaleString()} <span className="text-sm">HTG</span></span>
                        </div>
                        
                        <div className="space-y-3">
                            <Label className="text-[9px] font-black uppercase tracking-[0.2em] text-gray-400 ml-1">Kantite Lajan w ap Retire (HTG)</Label>
                            <Input
                                type="number"
                                placeholder={`Maksimòm: ${wallet.available_balance}`}
                                className="h-16 rounded-2xl bg-gray-50 border-none px-6 font-black text-gray-900 text-2xl text-center"
                                value={withdrawAmount}
                                onChange={(e) => setWithdrawAmount(e.target.value)}
                                max={wallet.available_balance}
                                min={500}
                                required
                            />
                            <p className="text-[9px] text-gray-400 font-bold text-center mt-2">Nòt: Retrè minimòm lan se 500 HTG.</p>
                        </div>
                        
                        <div className="space-y-3">
                            <Label className="text-[9px] font-black uppercase tracking-[0.2em] text-gray-400 ml-1">Nimewo MonCash Moun K ap Resevwa Lajan An</Label>
                            <Input
                                type="tel"
                                placeholder="Egz: +509 3000 0000"
                                className="h-14 rounded-2xl bg-gray-50 border-none px-6 font-black text-gray-900 tracking-widest"
                                value={withdrawPhone}
                                onChange={(e) => setWithdrawPhone(e.target.value)}
                                required
                            />
                        </div>

                        <Button type="submit" disabled={withdrawLoading || !withdrawAmount || !withdrawPhone || withdrawAmount > wallet.available_balance || withdrawAmount < 500} className="w-full h-16 bg-blue-600 hover:bg-blue-700 text-white font-black text-sm rounded-[25px] shadow-2xl shadow-blue-600/20 tracking-widest uppercase mt-4">
                            {withdrawLoading ? <Loader2 className="w-6 h-6 animate-spin" /> : "Voye Demann Nan Kounye A"}
                        </Button>
                    </form>
                </DialogContent>
            </Dialog>

            {/* DELIVERY REQUEST MODAL */}
            <Dialog open={showDeliveryModal} onOpenChange={setShowDeliveryModal}>
                <DialogContent className="sm:max-w-[500px] p-0 overflow-hidden rounded-[45px] border-none shadow-[0_0_100px_rgba(0,0,0,0.1)]">
                    <DialogHeader className="p-10 pb-6 bg-[#232F3E] text-white">
                        <div className="w-12 h-12 bg-[#FF9900] rounded-2xl flex items-center justify-center mb-4 shadow-xl shadow-orange-500/20">
                            <MapPin className="w-6 h-6 text-white" />
                        </div>
                        <DialogTitle className="text-2xl font-black tracking-tighter uppercase italic leading-none">Mande yon <span className="text-[#FF9900]">Chofè</span></DialogTitle>
                        <DialogDescription className="text-gray-400 font-bold uppercase tracking-widest text-[9px] mt-2">Konfime distans la pou n voye yon moto/machin.</DialogDescription>
                    </DialogHeader>
                    <div className="p-10 space-y-8 bg-white">
                        <div className="bg-gray-50 rounded-[30px] p-6 border border-gray-100 shadow-inner">
                            <div className="flex justify-between items-center mb-4">
                                <span className="text-[10px] font-black text-gray-400 uppercase tracking-widest">ADRÈS KLIYAN:</span>
                                <span className="text-[10px] font-black text-[#FF9900] uppercase tracking-widest">LIVREZON</span>
                            </div>
                            <p className="font-black text-gray-900 leading-tight italic text-lg uppercase tracking-tighter">{selectedOrder?.delivery_info?.address || "Atant..."}</p>
                        </div>

                        <div className="space-y-4">
                            <Label className="text-[10px] font-black uppercase tracking-widest text-gray-400">DISTANS (KILOMÈT/KM)</Label>
                            <div className="relative group">
                                <Input
                                    type="number"
                                    placeholder="5.5"
                                    value={distanceKm}
                                    onChange={(e) => setDistanceKm(e.target.value)}
                                    className="h-16 rounded-[20px] bg-gray-50 border-gray-100 px-8 font-black text-2xl text-gray-900 focus:border-[#FF9900] group-hover:border-gray-200 transition-all"
                                />
                                <span className="absolute right-8 top-1/2 -translate-y-1/2 font-black text-gray-400 text-sm">KM</span>
                            </div>
                            {distanceKm && (
                                <div className="flex justify-between items-center px-6 py-4 bg-orange-50 rounded-[25px] border border-orange-100 animate-in fade-in slide-in-from-top-2 duration-500">
                                    <div className="flex flex-col">
                                        <span className="text-[9px] font-black text-orange-600 uppercase tracking-widest mb-1">PRI LIVREZON:</span>
                                        <span className="text-xs font-bold text-orange-400 uppercase italic">25 HTG / KM</span>
                                    </div>
                                    <span className="text-3xl font-black text-[#FF9900] italic tracking-tighter">{(parseFloat(distanceKm) * 25).toLocaleString()} <span className="text-xs">HTG</span></span>
                                </div>
                            )}
                        </div>

                        <Button
                            onClick={handleRequestDelivery}
                            disabled={requestLoading || !distanceKm}
                            className="w-full h-20 bg-[#FF9900] hover:bg-[#E88B00] text-black font-black text-xl rounded-[30px] shadow-2xl shadow-orange-500/20 tracking-tight uppercase transition-all flex items-center justify-center gap-4 active:scale-95"
                        >
                            {requestLoading ? <Loader2 className="w-6 h-6 animate-spin" /> : "VOYE DEMANN LAN KOUNYE A"}
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>
 
             {/* LIST QUOTE MODAL */}
             <Dialog open={showQuoteModal} onOpenChange={setShowQuoteModal}>
                 <DialogContent className="sm:max-w-[600px] p-0 overflow-hidden rounded-[50px] border-none shadow-2xl">
                     <DialogHeader className="p-12 pb-8 bg-[#232F3E] text-white">
                         <div className="w-14 h-14 bg-[#FF9900] rounded-2xl flex items-center justify-center mb-6 shadow-xl shadow-[#FF9900]/20">
                             <ClipboardList className="w-8 h-8 text-white" />
                         </div>
                         <DialogTitle className="text-3xl font-black tracking-tighter uppercase italic leading-none">Mete <span className="text-[#FF9900]">Pri</span></DialogTitle>
                         <DialogDescription className="text-gray-400 font-bold uppercase tracking-widest text-[9px] mt-2">Mete pri pou chak atik kliyan an mande a.</DialogDescription>
                     </DialogHeader>
 
                     <form onSubmit={handleQuoteSubmit} className="p-12 space-y-8 bg-white max-h-[70vh] overflow-y-auto">
                         <div className="bg-orange-50 p-6 rounded-[30px] border border-orange-100 mb-8">
                             <p className="text-[10px] font-black text-orange-600 uppercase tracking-widest mb-2">Lis Kliyan an:</p>
                             <p className="text-sm font-bold text-gray-700 italic">"{selectedList?.items_text}"</p>
                         </div>
 
                         <div className="space-y-6">
                             {quoteItems.map((item, idx) => (
                                 <div key={idx} className="p-6 bg-gray-50 rounded-[30px] space-y-4 relative border border-gray-100 shadow-sm">
                                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                         <div className="space-y-2">
                                             <Label className="text-[10px] font-black uppercase text-gray-400">Non Atik</Label>
                                             <Input 
                                                 value={item.name} 
                                                 onChange={(e) => {
                                                     const newItems = [...quoteItems];
                                                     newItems[idx].name = e.target.value;
                                                     setQuoteItems(newItems);
                                                 }}
                                                 placeholder="Egz: Paracetamol"
                                                 className="h-12 rounded-xl bg-white border-gray-100 font-bold"
                                                 required
                                             />
                                         </div>
                                         <div className="space-y-2">
                                             <Label className="text-[10px] font-black uppercase text-gray-400">Pri (HTG)</Label>
                                             <Input 
                                                 type="number"
                                                 value={item.price_htg} 
                                                 onChange={(e) => {
                                                     const newItems = [...quoteItems];
                                                     newItems[idx].price_htg = e.target.value;
                                                     setQuoteItems(newItems);
                                                 }}
                                                 placeholder="500"
                                                 className="h-12 rounded-xl bg-white border-gray-100 font-bold"
                                                 required
                                             />
                                         </div>
                                     </div>
                                     {quoteItems.length > 1 && (
                                         <button 
                                             type="button"
                                             onClick={() => setQuoteItems(quoteItems.filter((_, i) => i !== idx))}
                                             className="absolute -top-2 -right-2 w-8 h-8 bg-white border border-red-50 text-red-500 rounded-full flex items-center justify-center shadow-lg hover:bg-red-500 hover:text-white transition-all"
                                         >
                                             <Trash className="w-4 h-4" />
                                         </button>
                                     )}
                                 </div>
                             ))}
 
                             <Button 
                                 type="button" 
                                 variant="outline"
                                 onClick={() => setQuoteItems([...quoteItems, { name: "", price_htg: "", quantity: 1 }])}
                                 className="w-full h-12 rounded-xl border-dashed border-2 border-gray-200 text-gray-400 hover:text-[#FF9900] hover:border-[#FF9900]/30 transition-all font-black uppercase text-[10px] tracking-widest gap-2"
                             >
                                 <Plus className="w-4 h-4" /> Ajoute Atik
                             </Button>
                         </div>
 
                         <div className="pt-8 border-t border-gray-50 flex items-center justify-between">
                             <div className="flex flex-col">
                                 <span className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Total Quote:</span>
                                 <span className="text-3xl font-black text-gray-900 italic tracking-tighter">
                                     {quoteItems.reduce((acc, item) => acc + (parseFloat(item.price_htg) || 0), 0).toLocaleString()} <span className="text-xs">HTG</span>
                                 </span>
                             </div>
                             <Button
                                 type="submit"
                                 disabled={quoteLoading}
                                 className="h-16 px-12 bg-[#232F3E] text-white hover:bg-black rounded-[25px] font-black uppercase tracking-widest shadow-2xl transition-all"
                             >
                                 {quoteLoading ? <Loader2 className="w-6 h-6 animate-spin" /> : "VOYE QUOTE"}
                             </Button>
                         </div>
                     </form>
                 </DialogContent>
            </Dialog>

             {/* Receipt Preview Modal */}
             <Dialog open={showReceiptModal} onOpenChange={setShowReceiptModal}>
                 <DialogContent className="sm:max-w-[400px] p-0 overflow-hidden rounded-[30px] border-none shadow-2xl bg-[#EBEBEB]">
                     <DialogHeader className="p-6 pb-2 bg-[#232F3E] text-white">
                         <DialogTitle className="text-xl font-black tracking-tighter uppercase italic leading-none text-center">Aperçu <span className="text-[#FF9900]">Resi</span></DialogTitle>
                     </DialogHeader>
                     {receiptOrder && (
                         <div className="p-6 flex flex-col items-center">
                             <div className="bg-white p-4 shadow-lg mb-6 relative font-mono text-black text-[11px] leading-snug w-[280px]">
                                 {seller?.logo && (
                                     <div className="flex justify-center mb-2">
                                         <img src={seller.logo} alt="Logo" className="max-w-[60px] max-h-[60px] object-contain rounded" />
                                     </div>
                                 )}
                                 <h2 className="text-center border-b border-dashed border-black pb-1 mb-1 text-base font-bold uppercase mt-1">{seller?.store_name || 'BVGLINK POS'}</h2>
                                 {seller?.address && <p className="text-center text-[10px] m-0">{seller.address}</p>}
                                 {seller?.phone && <p className="text-center text-[10px] m-0 border-b border-dashed border-black pb-1 mb-1">Tel: {seller.phone}</p>}
                                 <h3 className="text-center text-sm mb-1">RESI VANT</h3>
                                 <p className="text-center">{new Date(receiptOrder.created_at || Date.now()).toLocaleDateString('fr-FR')} {new Date(receiptOrder.created_at || Date.now()).toLocaleTimeString('fr-FR')}</p>
                                 <div className="border-t border-dashed border-black my-1"></div>
                                 <p><span className="font-bold">CMD No:</span> {receiptOrder.id.slice(0,8).toUpperCase()}</p>
                                 <p><span className="font-bold">KLIYAN:</span> {receiptOrder.buyer_phone}</p>
                                 <p><span className="font-bold">KASYÈ:</span> {receiptOrder.cashier_name || 'N/A'}</p>
                                 <div className="border-t border-dashed border-black my-1"></div>
                                 <p className="font-bold underline">ATIK(Yo):</p>
                                 <p>{receiptOrder.product_title}</p>
                                 <div className="border-t border-dashed border-black my-1"></div>
                                 <div className="flex justify-between font-bold text-sm mt-1">
                                     <span>TOTAL:</span>
                                     <span>{(receiptOrder.seller_amount_htg || 0).toLocaleString()} HTG</span>
                                 </div>
                                 <p className="mt-2"><span className="font-bold">Peman:</span> {receiptOrder.payment_status === 'completed' ? 'PEYE' : 'AN ATANT'}</p>
                                 <div className="border-t border-dashed border-black my-1"></div>
                                 <div className="text-center mt-3 text-[9px]">
                                     <p>Mesi pou biznis ou!</p>
                                     <p>*** Powered by BVGLink ***</p>
                                 </div>
                             </div>
                             <div className="flex gap-4 w-full px-2">
                                 <Button 
                                     onClick={() => setShowReceiptModal(false)}
                                     variant="outline"
                                     className="flex-1 h-12 border-2 border-gray-300 text-gray-500 hover:bg-gray-100 rounded-xl font-black uppercase tracking-widest text-[9px]"
                                 >
                                     Fèmen
                                 </Button>
                                 <Button 
                                     onClick={executePrint}
                                     className="flex-1 h-12 bg-blue-600 text-white hover:bg-blue-700 rounded-xl flex items-center justify-center gap-2 font-black uppercase tracking-widest text-[9px] shadow-lg shadow-blue-200"
                                 >
                                     <Printer className="w-4 h-4"/> PDF
                                 </Button>
                             </div>
                         </div>
                     )}
                 </DialogContent>
             </Dialog>

             {/* Profile Edit Modal */}
             <Dialog open={showProfileModal} onOpenChange={setShowProfileModal}>
                 <DialogContent className="sm:max-w-[500px] p-0 overflow-hidden rounded-[45px] border-none shadow-[0_0_100px_rgba(0,0,0,0.1)] bg-white">
                     <DialogHeader className="p-10 pb-6 bg-[#232F3E] text-white">
                         <DialogTitle className="text-2xl font-black tracking-tighter uppercase italic leading-none flex items-center gap-2">Pwofil <span className="text-[#FF9900]">Magazen</span></DialogTitle>
                         <DialogDescription className="text-gray-400 font-bold uppercase tracking-widest text-[9px] mt-2">Mete Enfòmasyon sou magazen ou pou resi ak pwofil lan.</DialogDescription>
                     </DialogHeader>
                     <form onSubmit={handleProfileSubmit} className="p-10 space-y-6">
                         <div className="space-y-4">
                             <div className="space-y-2">
                                 <Label className="text-[10px] font-black uppercase text-gray-400 tracking-widest">Non Magazen</Label>
                                 <Input 
                                     value={profileData.store_name} 
                                     onChange={(e) => setProfileData({...profileData, store_name: e.target.value})} 
                                     placeholder="Non Magazen ou"
                                     className="h-12 bg-gray-50 border-gray-100 rounded-xl text-xs font-bold"
                                     required
                                 />
                             </div>
                             <div className="space-y-2">
                                 <Label className="text-[10px] font-black uppercase text-gray-400 tracking-widest">Logo Magazen an (Chaje Imaj la)</Label>
                                 <div className="flex flex-col sm:flex-row items-center gap-3">
                                     <div className="relative w-full sm:w-auto h-12 bg-[#FF9900]/10 border border-[#FF9900]/20 hover:bg-[#FF9900] text-[#FF9900] hover:text-white font-black uppercase text-[10px] tracking-widest rounded-xl px-4 flex items-center justify-center transition-all cursor-pointer">
                                         <span className="flex items-center gap-2 shadow-sm whitespace-nowrap">ðŸ“¸ UPLOAD FICHYE</span>
                                         <input 
                                             type="file" 
                                             accept="image/*"
                                             className="absolute inset-0 opacity-0 cursor-pointer w-full h-full"
                                             onChange={async (e) => {
                                                 const file = e.target.files[0];
                                                 if (file) {
                                                     toast.info("Ap chaje Imaj la...", { autoClose: 1500 });
                                                     const formData = new FormData();
                                                     formData.append('file', file);
                                                     try {
                                                         const res = await axios.post(`${API}/marketplace/upload`, formData);
                                                         setProfileData({...profileData, logo: res.data.url});
                                                         toast.success("Logo monte! Kounye a klike Sove.");
                                                     } catch (err) {
                                                         toast.error("Echèk nan upload logo a.");
                                                     }
                                                 }
                                             }}
                                         />
                                     </div>
                                     <Input 
                                         value={profileData.logo} 
                                         onChange={(e) => setProfileData({...profileData, logo: e.target.value})} 
                                         placeholder="Oswa mete URL li la"
                                         className="h-12 bg-gray-50 border-gray-100 rounded-xl text-xs font-bold flex-1 w-full"
                                     />
                                 </div>
                             </div>
                             <div className="space-y-2">
                                 <Label className="text-[10px] font-black uppercase text-gray-400 tracking-widest">Nimewo Telefòn</Label>
                                 <Input 
                                     value={profileData.phone} 
                                     onChange={(e) => setProfileData({...profileData, phone: e.target.value})} 
                                     placeholder="Egz: 5093xxxxxxx"
                                     className="h-12 bg-gray-50 border-gray-100 rounded-xl text-xs font-bold"
                                 />
                             </div>
                             <div className="space-y-2">
                                 <Label className="text-[10px] font-black uppercase text-gray-400 tracking-widest">Adrès Magazen an</Label>
                                 <Input 
                                     value={profileData.address} 
                                     onChange={(e) => setProfileData({...profileData, address: e.target.value})} 
                                     placeholder="Lari, Vil..."
                                     className="h-12 bg-gray-50 border-gray-100 rounded-xl text-xs font-bold"
                                 />
                             </div>
                             <div className="space-y-4 pt-4 border-t border-gray-100">
                                 <div className="flex justify-between items-center">
                                     <Label className="text-[10px] font-black uppercase text-gray-400 tracking-widest">Kasye Ou Yo</Label>
                                     <Button 
                                         type="button" 
                                         variant="outline" 
                                         size="sm"
                                         onClick={() => {
                                             const newCashiers = [...(profileData.cashiers || [])];
                                             newCashiers.push({ id: Date.now().toString(), name: "", pin: "" });
                                             setProfileData({...profileData, cashiers: newCashiers});
                                         }}
                                         className="h-8 rounded-lg text-[9px] font-black uppercase border-[#FF9900] text-[#FF9900]"
                                     >
                                         + Ajoute Kasye
                                     </Button>
                                 </div>
                                 {(profileData.cashiers || []).map((c, i) => (
                                     <div key={c.id || i} className="flex gap-2 items-center bg-gray-50 p-2 rounded-xl">
                                         <Input 
                                             placeholder="Non Kasye" 
                                             value={c.name} 
                                             onChange={e => {
                                                 const nc = [...profileData.cashiers];
                                                 nc[i].name = e.target.value;
                                                 setProfileData({...profileData, cashiers: nc});
                                             }} 
                                             className="h-10 text-xs font-bold bg-white"
                                         />
                                         <Input 
                                             placeholder="Kòd PIN" 
                                             type="password"
                                             maxLength={4}
                                             value={c.pin} 
                                             onChange={e => {
                                                 const nc = [...profileData.cashiers];
                                                 nc[i].pin = e.target.value;
                                                 setProfileData({...profileData, cashiers: nc});
                                             }} 
                                             className="h-10 text-xs font-bold bg-white w-24 text-center tracking-widest"
                                         />
                                         <Button 
                                             type="button" 
                                             variant="ghost" 
                                             className="text-red-500 w-10 h-10 p-0"
                                             onClick={() => {
                                                 const nc = profileData.cashiers.filter((_, idx) => idx !== i);
                                                 setProfileData({...profileData, cashiers: nc});
                                             }}
                                         >
                                             <Trash2 className="w-4 h-4" />
                                         </Button>
                                     </div>
                                 ))}
                             </div>
                         </div>
                         <Button
                             type="submit"
                             disabled={profileLoading}
                             className="w-full h-14 bg-[#FF9900] hover:bg-black text-white font-black uppercase tracking-widest text-[10px] rounded-[20px] transition-all shadow-xl shadow-orange-500/20 mt-4"
                         >
                             {profileLoading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Sove Pwofil la"}
                         </Button>
                     </form>
                 </DialogContent>
             </Dialog>

             <Dialog open={showScannerModal} onOpenChange={setShowScannerModal}>
                 <DialogContent className="sm:max-w-[400px] p-0 overflow-hidden rounded-[30px] border-none shadow-2xl bg-[#EBEBEB]">
                     <DialogHeader className="p-6 pb-2 bg-[#232F3E] text-white">
                         <DialogTitle className="text-xl font-black tracking-tighter uppercase italic leading-none text-center">Eskane <span className="text-[#FF9900]">Atik Bò Kès</span></DialogTitle>
                     </DialogHeader>
                     <div className="p-4 flex flex-col items-center pb-6">
                         {showScannerModal && (
                             <BarcodeScanner 
                                 onResult={handleBarcodeResult} 
                                 onClose={() => setShowScannerModal(false)}
                             />
                         )}
                     </div>
                 </DialogContent>
             </Dialog>

             <Dialog open={showCashCalculatorModal} onOpenChange={setShowCashCalculatorModal}>
                 <DialogContent className="sm:max-w-[400px] p-0 overflow-hidden rounded-[40px] border-none shadow-2xl bg-[#EBEBEB]">
                     <DialogHeader className="p-8 pb-4 bg-[#232F3E] text-white flex flex-col items-center relative">
                         <div className="absolute -top-4 right-8 w-24 h-24 bg-white/5 rounded-full blur-2xl"></div>
                         <div className="w-16 h-16 bg-[#FF9900]/20 rounded-full flex items-center justify-center mb-4 ring-8 ring-[#FF9900]/5">
                             <DollarSign className="w-8 h-8 text-[#FF9900]" />
                         </div>
                         <DialogTitle className="text-2xl font-black uppercase tracking-tighter italic">Fè Monnen</DialogTitle>
                         <p className="text-[10px] text-white/50 font-black uppercase tracking-widest mt-2 px-8 text-center leading-relaxed">Kalkile kòb pou w remèt kliyan an fasil</p>
                     </DialogHeader>
                     <div className="p-8 pb-10 flex flex-col gap-6 relative">
                         <div className="bg-white rounded-3xl p-6 flex flex-col gap-3 shadow-lg shadow-black/5 transform hover:scale-[1.02] transition-transform">
                            <div className="flex justify-between items-center text-[10px] font-black uppercase text-gray-400 tracking-widest">
                                <span>Kòb Atik Yo Fè:</span>
                                <span className="text-gray-900 text-sm bg-gray-50 px-3 py-1 rounded-lg">{posCart.reduce((sum, item) => sum + (item.price_htg * item.qty), 0).toLocaleString()} HTG</span>
                            </div>
                            <div className="flex justify-between items-center mt-2 group">
                                <span className="text-[10px] font-black uppercase text-gray-400 tracking-widest leading-tight">Moun Nan<br/>Bay:</span>
                                <Input 
                                    type="number" 
                                    value={amountTendered} 
                                    onChange={(e) => setAmountTendered(e.target.value)}
                                    placeholder="Eg: 500"
                                    className="w-32 h-14 bg-gray-50 border-gray-100/50 rounded-2xl text-right text-xl font-black text-[#FF9900] shadow-inner focus:ring-4 ring-[#FF9900]/20 transition-all"
                                    autoFocus
                                />
                            </div>
                            {/* Fast cash buttons */}
                            <div className="flex flex-wrap gap-2 justify-end mt-3 border-t border-gray-50 pt-3">
                                {[posCart.reduce((sum, item) => sum + (item.price_htg * item.qty), 0), 250, 500, 1000, 2500, 5000].map(val => (
                                    <button 
                                        key={'cash'+val} 
                                        onClick={() => setAmountTendered(val.toString())}
                                        className="px-3 py-2 bg-blue-50 text-blue-600 rounded-xl text-[9px] font-black uppercase tracking-widest hover:bg-blue-600 hover:text-white transition-colors border border-blue-100 hover:border-blue-600"
                                    >
                                        {val === posCart.reduce((sum, item) => sum + (item.price_htg * item.qty), 0) ? 'Egzak' : val}
                                    </button>
                                ))}
                            </div>
                         </div>
                         
                         {(() => {
                             const total = posCart.reduce((sum, item) => sum + (item.price_htg * item.qty), 0);
                             const tendered = parseFloat(amountTendered || 0);
                             const change = tendered - total;
                             return (
                                 <div className={`rounded-3xl p-6 shadow-xl border-2 transition-all duration-300 ${tendered >= total ? 'bg-green-500 border-green-400/50 shadow-green-500/20 text-white' : 'bg-white border-red-100 shadow-red-500/5'}`}>
                                    <div className="flex flex-col items-center">
                                        <span className={`text-[10px] font-black uppercase tracking-widest ${tendered >= total ? 'text-green-100' : 'text-red-500'}`}>
                                            {tendered >= total ? 'Monnen Pou Remèt:' : 'Rès Kòb Pou L Bay:'}
                                        </span>
                                        <span className={`text-4xl font-black italic tracking-tighter mt-2 ${tendered >= total ? 'text-white' : 'text-red-500'}`}>
                                            {Math.abs(change).toLocaleString()} <span className="text-sm uppercase tracking-widest">HTG</span>
                                        </span>
                                    </div>
                                 </div>
                             );
                         })()}

                         <Button 
                             onClick={async () => {
                                 const total = posCart.reduce((sum, item) => sum + (item.price_htg * item.qty), 0);
                                 const tendered = parseFloat(amountTendered || 0);
                                 if (tendered < total) return toast.error("Kòb li bay la pa kont pou regle afè a!");
                                 
                                 const cashierName = activeCashier ? activeCashier.name : "Pwopriyetè";
                                 try {
                                     const deliveryFee = posDeliveryEnabled && posDeliveryKm ? parseFloat(posDeliveryKm) * 25 : 0;
                                     const pbx = await axios.post(`${API}/marketplace/orders`, {
                                         buyer_name: "Kliyan POS",
                                         buyer_phone: posBuyerPhone || "POS",
                                         delivery_address: posDeliveryEnabled && posDeliveryAddress ? posDeliveryAddress : "Anndan Magazen",
                                         seller_id: seller?.id || seller?._id,
                                         items: posCart.map(item => ({
                                             product_id: item.id,
                                             product_title: item.title,
                                             price: item.price_htg,
                                             quantity: item.qty
                                         })),
                                         total_htg: total + deliveryFee,
                                         payment_method: "cash",
                                         delivery_method: posDeliveryEnabled ? "delivery" : "pickup",
                                         cashier_name: cashierName
                                     });
                                     
                                     // Make sure we mark this order as PAID locally immediately so it shows 'completed'
                                     await axios.post(`${API}/marketplace/orders/${pbx.data.order_id}/status`, { status: "completed" });

                                     // If delivery was requested, broadcast to drivers
                                     if (posDeliveryEnabled && posDeliveryKm) {
                                         try {
                                             const token = localStorage.getItem("seller_token");
                                             await axios.post(`${API}/marketplace/orders/${pbx.data.order_id}/request-delivery`, {
                                                 distance_km: parseFloat(posDeliveryKm)
                                             }, { headers: { Authorization: `Bearer ${token}` } });
                                             toast.success("Demann livrezon voye bay chofè ki disponib yo!");
                                         } catch (delivErr) {
                                             console.warn("Could not broadcast delivery request:", delivErr);
                                             toast.info("Komand enrejistre. Al nan tab Komand yo pou mande chofè manyelman.");
                                         }
                                     }

                                     fetchInitialData();
                                 } catch (err) {
                                     console.error(err);
                                     toast.error("Echèk nan sove vant lan nan baz done a.");
                                 }

                                 const fauxOrder = {
                                     id: "POS-" + Date.now().toString(36).toUpperCase(),
                                     created_at: new Date().toISOString(),
                                     buyer_phone: posBuyerPhone,
                                     product_title: posCart.map(i => `${i.qty}x ${i.title}`).join(', '),
                                     seller_amount_htg: total,
                                     cashier_name: cashierName,
                                     tendered_htg: tendered,
                                     change_htg: tendered - total,
                                     payment_status: 'completed'
                                 };
                                 handlePrintReceipt(fauxOrder);
                                 toast.success("Vant anrejistre pou " + posBuyerPhone);
                                 setPosCart([]);
                                 setPosBuyerPhone("");
                                 setPosDeliveryEnabled(false);
                                 setPosDeliveryAddress("");
                                 setPosDeliveryKm("");
                                 setShowCashCalculatorModal(false);
                                 setAmountTendered("");
                             }}
                             disabled={parseFloat(amountTendered || 0) < posCart.reduce((sum, item) => sum + (item.price_htg * item.qty), 0)}
                             className="w-full h-16 bg-[#232F3E] hover:bg-gray-900 text-white font-black uppercase text-xl rounded-2xl shadow-xl disabled:opacity-50 tracking-tighter flex items-center justify-center gap-3 mt-2 border-b-4 border-black/20"
                         >
                             <Check className="w-6 h-6 text-[#FF9900]" /> Konfime Vant La
                         </Button>
                     </div>
                 </DialogContent>
             </Dialog>

            {/* FAST POS ADD MODAL */}
            <Dialog open={showFastPosModal} onOpenChange={setShowFastPosModal}>
                <DialogContent className="sm:max-w-[400px] p-0 overflow-hidden rounded-[40px] border-none shadow-2xl">
                    <DialogHeader className="p-8 bg-gray-50 flex flex-col items-center border-b border-gray-100">
                        <div className="w-12 h-12 bg-green-100 rounded-2xl flex items-center justify-center mb-4 text-green-500">
                            <PlusCircle className="w-6 h-6" />
                        </div>
                        <DialogTitle className="text-xl font-black tracking-tighter uppercase italic text-center text-gray-900">
                            Ajoute Pwodwi Lokal
                        </DialogTitle>
                        <DialogDescription className="text-gray-400 font-bold uppercase tracking-widest text-[8px] text-center mt-2">
                            Pyès Lòt Moun pap wèl nan Marketplace la (POS Sèlman)
                        </DialogDescription>
                    </DialogHeader>

                    <form onSubmit={handleFastPosSubmit} className="p-8 space-y-6 bg-white">
                        <div className="space-y-4">
                            <Label className="text-[10px] font-black uppercase tracking-widest text-gray-400">Non Pwodwi an</Label>
                            <Input
                                placeholder="Egz: Coca Cola 20oz"
                                className="h-12 rounded-xl bg-gray-50 text-sm font-bold shadow-sm border border-gray-100 hover:border-green-500 focus:border-green-500"
                                value={fastPosFormData.title}
                                onChange={(e) => setFastPosFormData({ ...fastPosFormData, title: e.target.value })}
                                required
                            />
                        </div>
                        
                        <div className="grid grid-cols-2 gap-4">
                            <div className="space-y-4">
                                <Label className="text-[10px] font-black uppercase tracking-widest text-gray-400">Pri (HTG)</Label>
                                <Input
                                    type="number"
                                    placeholder="Egz: 150"
                                    className="h-12 rounded-xl bg-gray-50 text-sm font-bold shadow-sm border border-gray-100 hover:border-green-500 focus:border-green-500"
                                    value={fastPosFormData.price_htg}
                                    onChange={(e) => setFastPosFormData({ ...fastPosFormData, price_htg: e.target.value })}
                                    required
                                />
                            </div>
                            <div className="space-y-4">
                                <Label className="text-[10px] font-black uppercase tracking-widest text-gray-400">Kantite (Opsyonèl)</Label>
                                <Input
                                    type="number"
                                    placeholder="Egz: Pa mete anyen si l infini"
                                    className="h-12 rounded-xl bg-gray-50 text-sm font-bold shadow-sm border border-gray-100 hover:border-green-500 focus:border-green-500"
                                    value={fastPosFormData.stock}
                                    onChange={(e) => setFastPosFormData({ ...fastPosFormData, stock: e.target.value })}
                                />
                            </div>
                        </div>

                        <div className="space-y-4">
                            <Label className="text-[10px] font-black uppercase tracking-widest text-gray-400">Kategori</Label>
                            <select
                                className="w-full h-12 rounded-xl bg-gray-50 px-4 font-bold text-sm outline-none border border-gray-100 hover:border-green-500 focus:border-green-500"
                                value={fastPosFormData.category}
                                onChange={(e) => setFastPosFormData({ ...fastPosFormData, category: e.target.value })}
                            >
                                <option value="food">Manje Sèlman</option>
                                <option value="bwason">Bwason & Likid</option>
                                <option value="construction">Materyo Konstriksyon</option>
                                <option value="pharmacy">Famasi</option>
                                <option value="autoparts">Auto Parts</option>
                                <option value="depotalimentaire">Depot Alimentaire</option>
                                <option value="phones">Telefòn & Tablet</option>
                                <option value="electronics">Elektwonik</option>
                                <option value="services">Sèvis</option>
                                <option value="fashion">Rad & Mòd</option>
                                <option value="other">Lòt Bagay</option>
                            </select>
                        </div>

                        <div className="flex gap-4 pt-4 border-t border-gray-50">
                            <Button 
                                type="button" 
                                variant="outline" 
                                onClick={() => setShowFastPosModal(false)}
                                className="flex-1 h-12 rounded-xl text-[10px] font-black uppercase tracking-widest border-2 border-gray-100"
                            >
                                Anile
                            </Button>
                            <Button 
                                type="submit"
                                disabled={addLoading} 
                                className="flex-1 h-12 bg-green-500 hover:bg-green-600 text-white rounded-xl text-[10px] font-black uppercase tracking-widest shadow-xl shadow-green-500/20"
                            >
                                {addLoading ? <div className="loading-spinner w-4 h-4" /> : "Sove Pwodwi"}
                            </Button>
                        </div>
                    </form>
                </DialogContent>
            </Dialog>

             <Footer />
            </main>
        </div>
    );
};

export default SellerDashboard;


